import { State } from "../state";
import {
  commitSetLabelInfo,
  commitCaseControl,
  commitSetPerformancePageList,
  commitSetPerformances,
  commitSetPerformanceSelectOptions,
  commitSetPerformanceTableFields,
  commitSetPerfSecondData,
  commitPkgAssetTrend,
  commitResourceScanCarList,
  commitSpeedmMemoryConfig,
  commitSetMemorySubStack,
  commitSetProtocolReport,
  commitResourceScanChart,
  commitSetProtocolList,
  commitSetObjectFunctionId,
  commitMemoryResouceSpeedOptions,
  commitMemoryResouceVehicle,
  commitResourceScanCarData,
  commitResourceScanLoadList,
  commitMemSummaryTrend,
  commitResourceHistory,
  commitResourceScanChartAvg,
  commitMemSummaryTrendiOS,
  commitResourceId,
  commitResourceScanTypeList,
  commitResourceScanDates,
  commitResourceDevices,
  commitResourceScanSkinList,
  commitResourceScenes,
  commitResourceScanAverageData,
  commitSetNewSmgReport,
  commitResourceOverall,
  commitResourceRecords,
  commitSpeedmMemorySummary,
  commitSetSmgReport,
  commitSetSgameSkinData,
  commitMemDateVersions,
  commitSpeedmModSummaryV1,
  commitXcodeNativeFuncTrend,
  commitSetSgameSkinOption,
  commitSpeedmSourceFilesList,
  commitSetSkinTabListGet,
  commitPkgMapStructStackList,
  commitPkgAbnormalTrend,
  commitXcodeNativeModule,
  commitPkgResourceListThreadOld,
  commitLightCommonKey,
  commitLightCommonUrl,
  commitSetLoginSmokeReport,
  commitSpeedmModList,
  commitMemSummartListV1,
  commitPerfettoModuleTrend,
  commitPerfettoModuleList,
  commitSetLoginSmokeReportList,
  commitXcodeNativeAll,
  commitXcodeStack,
  commitXcodeSoAll,
  commitXcodeTypeOptions,
  commitSpeedmModResList,
  commitXcodeSoFuncTrend,
  commitSetMemoryModuleListAppoint,
  commitPerfettoOldOptions,
  commitSpeedmResSummaryList,
  commitXcodeReport,
  commitXcodeSoList,
  commitXcodeDeviceOptions,
  commitXcodeDimensOptions,
  commitPkgAssetType,
  commitXcodeNativeTrend,
  commitXcodeLevelOptions,
  commitPerformanceSvgLogData,
  commitSpeedmModSummary,
  commitXcodeSceneOptions,
  commitSetMemoryDateVersionDevice,
  commitSpeedmMemoryRecords,
  commitSetMemoryLlmList,
  commitLightSmokeScenes,
  commitLightSmokeDevices,
  commitSetMemoryModuleListAppointOld,
  commitSetObjectMemoryModuleListId,
  commitLightSmokeTodDevices,
  commitMemSummartList,
  commitLightSmokeList,
  commitPerformanceDsLog,
  commitLightSmokeVersions,
  commitPerfettoStackSearchV2,
  commitPerformanceDsLogData,
  commitSpeedmMemoryScens,
  commitDeepPerformanceCpuLabelsOld,
  commitSetMemoryFunctionAppointOld,
  commitSpeedmMemoryResTrend,
  commitSpeedmMemoryTrend,
  commitSpeedmMemoryResSummary,
  commitSpeedmFilenameList,
  commitSetTestInfo,
  commitSetMemoryListData,
  commitSetMemoryAppointStack,
  commitSpeedmMemoryList,
  commitPerfettoDownLoadStack,
  commitDeepPerformanceCatonList,
  commitSetMemoryAppointOldLeftStack,
  commitSetMemoryFunctionTrendAll,
  commitSetMemoryAppointOldRightStack,
  commitSetMemoryAllStack,
  commitAndroidOfflineZip,
  commitSetMemoryAllStackOld,
  commitPerformanceSvgLog,
  commitSetMemoryFunctionAppoint,
  commitSetMemorModuleSubTrend,
  commitSimpleUrl,
  commitSetMemoryUobject,
  commitSetMemoryStack,
  commitSetMemoryStackOld,
  commitSetMemorySubStackOld,
  commitSetLabelInfoLabel,
  commitSetObjectFunctionTrend,
  commitObjectFuncAll,
  commitSetMemoryDateVersionNew,
  commitDeepPerformanceCpufuncTrend,
  commitSetMemoryDeviceSecond,
  commitSetPerformanceCustomVersionList,
  commitSetMemoryUobjectTrend,
  commitSetObjectFunctionTrendDraw,
  commitSetObjectMemoryReport,
  commitSetMemoryModuleListSecond,
  commitPerfettoNativeAll,
  commitPerfettoStackSearchSo,
  commitPerfettoStackSearchFuncitons,
  commitSetObjectMemoryLevel,
  commitSetMemoryType,
  commitSetMemoryModuleList,
  commitSetMemoryDateVersion,
  commitCpuTrend,
  commitPerfettoSoFuncTrend,
  commitSetMemoryList,
  commitPerfettoStackSearch,
  commitSetMemorModuleTrend,
  commitDeepPerformancFlameGraphUrl,
  commitSetObjectMemorySceneSecond,
  commitSetObjectMemorymoduleAll,
  commitSetSkinReportList,
  commitSetMemoryVersion,
  commitSetMemoryDevice,
  commitPkgMapStructStackOption,
  commitSetMemoryScene,
  commitDeepPerformanceAvgStack,
  commitPerfettoStack,
  commitSetMemoryDate,
  commitDeepPerformanceCpuThreadList,
  commitDeepPerformanceCpuThreadTrend,
  commitSetCaseMonitorList,
  commitXcodeDateOptions,
  commitPerfettoSoList,
  commitPkgMapStructStack,
  commitDeepPerformanceCpuUsageListQQ,
  commitPerfettoSoAll,
  commitDeepPerformanceCputhreadByFrame,
  commitPerfettoSceneOptions,
  commitPerfettoTypeOptions,
  commitPerfettoNativeModule,
  commitSetCaseMonitor,
  commitDeepPerformanceFrameProblem,
  commitTokenLibraryList,
  commitPerfettoSettings,
  commitPerfettoNativeFuncTrend,
  commitSetArrange,
  commitDeepPerformanceCpuUsageListModuleQQ,
  commitDeepPerformanceCpuCustomData,
  commitPerfettoDeviceOptionsTrend,
  commitPerfettoOptionsOld,
  commitSetTopTemplatesData,
  commitDeepPerformanceCpuUsageList,
  commitSetSkinReportWhole,
  commitPerfettoNativeTrend,
  commitPerfettoDeviceOptionsImportant,
  commitPerfettoLevelOptions,
  commitSetSkinTableReport,
  commitPerfettoReport,
  commitDeepPerformanceCpuReport,
  commitPerfettoDeviceOptions,
  commitPerfettoOptions,
  commitSetTopBaselines,
  commitCpuFuncDeivces,
  commitSetTopBaselinesData,
  commitSetSkinReportOptionOld,
  commitDeepPerformanceCpuPerfTrend,
  commitDeepPerformanceFpsInsideTrend,
  commitDeepPerformanceCpuConfigSoList,
  commitCpuFuncScenes,
  commitPkgStructTrend,
  commitDeepPerformanceCpuConfig,
  commitSetSkinReportComparedata,
  commitSetSkinReportdata,
  commitPkgAssetStack,
  commitPkgResourceReport,
  commitSetAddBug,
  commitPkgStructStack,
  commitSetSkinReportOption,
  commitSetPerformancePageListSummary,
  commitDeepPerformancefuncList,
  commitSetMemreportData,
  commitPkgAssetStackFind,
  commitDeepPerformanceTrendNode,
  commitSetDeepPerformanceSimpleDetail,
  commitSetUploadTopPerformanceUpload,
  commitDeepPerformanceCpuStackMerge,
  commitSetDeepMemoryDataCreadOld,
  commitSetMemoryDownLoad,
  commitSetDeepMemoryDataCread,
  commitAndroidOfflineeThreadOldList,
  commitSetDeepPerformanceSelectOptionsOld,
  commitAndroidOfflineDate,
  commitAndroidOfflineOldDate,
  commitAbdUrl,
  commitLightPerfUrl,
  commitDeepPerformanceCpuFuncReport,
  commitAndroidOfflineUrl,
  commitAndroidAppFileUrl,
  commitSetDeepPerformanceSelectOptionsLast,
  commitDeepPerformanceCpuStackFind,
  commitAndroidThreadTrend,
  commitAndroidOfflineeList,
  commitAndroidOfflineeOldList,
  commitAndroidCourseCompare,
  commitDeepPerformanceCpuFunctionOverview,
  commitSetDeepPerformanceCpuPutCheck,
  commitAndroidThreadCompare,
  commitAndroidThreadOptions,
  commitAndroidCourseProcessList,
  commitResourceVersions,
  commitAndroidThreadProcessList,
  commitAndroidCourseOptions,
  commitAndroidCourseTrend,
  commitDeepPerformanceCpuStackCreated,
  commitAndroidOfflineeScenes,
  commitAndroidOfflineeSubtypes,
  commitDeepPerformanceCpuStackCreatedOld,
  commitDeepPerformanceCpuModuleTrend,
  commitDeepPerformanceCpuCustomTrend,
  commitDeepPerformanceCpuStack,
  commitDeepPerformanceCpuFunctionModel,
  commitAndroidOfflineeDevice,
  commitSetUnityMemoryReport,
  commitDeepPerformanceCpuFunction,
  commitSetUnityMemoryList,
  commitSetObjectMemoryTrend,
  commitDeepPerformanceCpuByFrame,
  commitDeepPerformanceCpuFunctionCos,
  commitAndroidAppDateContrast,
  commitDeepPerformanceCpuVersions,
  commitAndroidAppFilename,
  commitDeepPerformanceCpuSoTrend,
  commitAndroidAppZip,
  commitDeepPerformanceCpuVersionsOld,
  commitDeepPerformanceCpuLabels,
  commitDeepPerformanceCpuThreads,
  commitPkgResourceTrend,
  commitPkgTypeRate,
  commitAndroidAppFileTrend,
  commitAndroidAppSubtype,
  commitAndroidAppLog,
  commitAndroidAppDevice,
  commitPkgTypeTable,
  commitAndroidAppFileCompare,
  commitPkgTypeListOld,
  commitPkgResourceSum,
  commitAndroidAppFileData,
  commitAndroidAppScene,
  commitAbdProcessCompare,
  commitAbdLog,
  commitPkgResourceList,
  commitPkgResourceScenes,
  commitPkgTypeList,
  commitSmokeByReport,
  commitPerfettoLevelOptionsImportant,
  commitAndroidAppDate,
  commitLightPerfDateContrast,
  commitLightPerfScene,
  commitPkgResourceDevice,
  commitPkgResourceDate,
  commitDeepPerformanceCpuTrend,
  commitLightPerfResourceCost,
  commitLightPerfJankCost,
  commitLightPerfMethodCost,
  commitLightMethod,
  commitLightPerfTrend,
  commitLightPerfFunctions,
  commitLightJank,
  commitLightResource,
  commitLightPerfLog,
  commitSimpleThreadOptions,
  commitSimpleLog,
  commitSetDeepMemoryData,
  commitSetMemoryCircleChar,
  commitAbdDateSingle,
  commitAbdCompare,
  commitLightPerfSubtype,
  commitLightPerfDate,
  commitLightPerfDevice,
  commitSetMemoryOptions,
  commitSetMemoryRecordList,
  commitSetMemorySubSceneOptions,
  commitSetMemoryDateOptions,
  commitSimpleSoOptions,
  commitSetMemoryTrend,
  commitAbdSum,
  commitSetMemoryReport,
  commitSimpleVersionOptions,
  commitPkgResourceListOld,
  commitSimpleSceneOptions,
  commitSimpleProcessOptions,
  commitSetPerfReport,
  commitSetMemorySceneOptions,
  commitSimpleVersionOptionsOld,
  commitSimpleTable,
  commitSimpleTotalTrend,
  commitSimpleTrendParams,
  commitSimpleLabelOptions,
  commitSetLiveReport,
  commitSetNewReport,
  commitAbdDateOptions,
  commitAbdProcess,
  commitLiveReportList,
  commitSetWeaponReport,
  commitSetPerfDashboard,
  commitSetDeepPerformanceCpuPutDetail,
  commitSimpleReportOptions,
  commitDeepPerformanceCpuDetail,
  commitAbdList,
  commitAbdType,
  commitAbdDeviceptions,
  commitAbdSubtypeOptions,
  commitSimpleSubtypeOptions,
  commitSetAllPerformances,
  commitAbdSceneOptions,
  commitSetReports,
  commitSimpleData,
  commitDeleteReport,
  commitSetPerfAvgdData,
  commitUpdateReport,
  commitSetNzmReport,
  commitsetGetPerformanceAnalysis,
  commitGetPerformanceAovTrend,
  commitPerformanceAovEmail,
  commitGetAovPerformances,
  commitLastRecord,
  commitRecentTaskrecord,
  commitSetUploadPerformance,
  commitTaskRecordQuery,
  commitTaskRecordDevices,
  commitAovPerformanceCopy,
  commitSetAovCopyPerfToReport,
  commitSetPerfInfo,
  commitDeepPerformanceCpuUsageTrend,
  commitNewReportList,
  commitSetDateVersion,
  commitSetCODMReport,
  commitSetCODMReportList,
  commitSimpleTaskOptions,
  commitDeleteCODMReport,
  commitSetTOPReportList,
  commitSetTOPReportDetail,
  commitSetTOPReport,
  commitSetTOPReportTable,
  commitSetTOPReportTableList,
  commitSetTOPReportGenerate,
  commitSetXhookReport,
  commitSetXhookReportList,
  commitSetWedoReport,
  commitSetSkinReport,
  commitSetTestCase,
  commitSetSkinReportInside,
  commitSetLogDownload,
  commitSetSmokeReport,
  commitSetSmokeReportList,
  commitSetLabelReport,
  commitSetPerformanceVersion,
  commitSetStressPerfReport,
  commitSetDeepPerformanceDetails,
  commitSetDeepPerformanceStack,
  commitSetDeepPerformancePageList,
  commitSetDeepPerformanceSelectOptions,
  commitSetInstantiation,
  commitSetInstantiations,
  commitSetChangeFPSlte,
  commitSetChangeFPSgte,
  commitSetPlayerid,
  commitSetPerfReportIdTest,
  commitSetDC,
  commitSetDcReport,
  commitSetDeepScene,
  commitSetTaskList,
  commitSetNzmMemoryStackAll,
  commitSetDeepFind,
  commitSetDeepSceneOld,
  commitSetDeepSceneVedio,
  commitSetDeepSceneOldVedio,
  commitSetDeepSceneOptions,
  commitSetDeepMemreport,
  commitSetSkinManagement,
  commitSetSkinLineView,
  commitSetUpdateSkinLineView,
  commitSetSkinLineDate,
  commitSetSkinLinePkg,
  commitSetTestCaseList,
  commitSpeedmSourceList,
  commitSetUploadTopPerformance,
  commitSimpleDateOptions,
  commitSimpleTypeOptions,
  commitSimpleDeviceOptions,
  commitSimpleByData,
  commitSpeedmModTrend,
  commitPkgMapStructTrend,
  commitSetTopTemplates
} from "./mutations";
import { PerformanceState } from "./state";
import { ActionContext } from "vuex";
import { getStoreAccessors } from "typesafe-vuex";
import { api } from "@/api";
import { dispatchCheckApiError } from "../task/actions";
import {
  EditLog,
  ICaseDetail,
  IUploadskin,
  ProblemSummay,
  UploadTopPerformanceTop,
  IControl,
  ICpuStackMerge,
  IMemory,
  IdeepDataCheck,
  TemplatesCreate,
  BaselinesCreate,
  IUploadCpuReport,
  IUploadDcReportSimple,
  IMark,
  INzmUploadReport,
  IPerformance,
  IPerformanceAovEmail,
  AddBug,
  IReport,
  IReportMarkCPU,
  ITOPReport,
  ITOPReportUpload,
  IUploadReport,
  IUploadReportSimple,
  UploadPerformance,
  UploadPerformanceAll,
  UploadTopPerformance,
  IUploadSmokeReporrt,
  ISkinDetail,
  
  ISimple,
  ISimpleTrend,
} from "@/interfaces";
import { ICopy,IAccount, IPipeline, IPipelinePkg, ISceneScriptCreate, IScript, ITask, ITaskControl } from '@/interfaces';
import { ElMessage } from "element-plus";
import { store } from "..";

type PerformanceContext = ActionContext<PerformanceState, State>;

export const actions = {
  async actionGetPerformances(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: number | "";
      scene_id: number | "";
      device_id: number | "";
    }
  ) {
    try {
      const response = await api.getPerformances(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.scene_id,
        payload.device_id
      );
      if (response.data) {
        commitSetPerformances(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProblemSummay(
    context: PerformanceContext,
    payload: {
      project: number;
      id_list:any,
      project_name:string
    
    }
  ) {
    try {
      const response = await api.problemSummay(
        context.rootState.main.token,
        payload.project,
        payload.id_list,
        payload.project_name,
        
      
       
     
      );
      if (response.data) {
        commitSetUploadTopPerformanceUpload(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopTemplates(
    context: PerformanceContext,
    payload: {
      project: number;
  
    
    }
  ) {
    try {
      const response = await api.topTemplates(
        context.rootState.main.token,
        payload.project,
    
        
      
       
     
      );
      if (response.data) {
        commitSetTopTemplates(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopBaselines(
    context: PerformanceContext,
    payload: {
      project: number;
  
    
    }
  ) {
    try {
      const response = await api.topBaselines(
        context.rootState.main.token,
        payload.project,
    
        
      
       
     
      );
      if (response.data) {
        commitSetTopBaselines(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopTemplatesData(
    context: PerformanceContext,
    payload: {
      id:any
      project: number;
  
    
    }
  ) {
    try {
      const response = await api.topTemplatesData(
        context.rootState.main.token,
        payload.id,
        payload.project,
    
        
      
       
     
      );
      if (response.data) {
        commitSetTopTemplatesData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopBaselinesData(
    context: PerformanceContext,
    payload: {
      id:any
      project: number;
  
    
    }
  ) {
    try {
      const response = await api.topBaselinesData(
        context.rootState.main.token,
        payload.id,
        payload.project,
    
        
      
       
     
      );
      if (response.data) {
        commitSetTopBaselinesData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionUploadPerformance(
    context: PerformanceContext,
    payload: UploadPerformance
  ) {
    try {
      const response = await api.uploadPerformance(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetUploadPerformance(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadDeepCpuUpload(
    context: PerformanceContext,
    payload: UploadPerformance
  ) {
    try {
      const response = await api.uploadDeepCpuUpload(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadTopPerformance(
    context: PerformanceContext,
    payload: UploadTopPerformance
  ) {
    try {
      const response = await api.uploadTopPerformance(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetUploadTopPerformance(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAddBug(
    context: PerformanceContext,
    payload: AddBug
  ) {
    try {
      const response = await api.addBug(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        return response.data
        // commitSetAddBug(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadTopPerformanceUpload(
    context: PerformanceContext,
    payload: UploadTopPerformanceTop
  ) {
    try {
      const response = await api.uploadTopPerformanceUpload(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetUploadTopPerformanceUpload(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadModelUpload(
    context: PerformanceContext,
    payload: {project:any,file:any}
  ) {
    try {
      const response = await api.uploadTopPerformanceModelUpload(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadTopPerformanceTable(
    context: PerformanceContext,
    payload: UploadTopPerformanceTop
  ) {
    try {
      const response = await api.uploadTopPerformanceTable(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTopTemplatesCreate(
    context: PerformanceContext,
    payload: TemplatesCreate
  ) {
    try {
      const response = await api.topTemplatesCreate(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTopBaselinesCreate(
    context: PerformanceContext,
    payload: BaselinesCreate
  ) {
    try {
      const response = await api.topBaselinesCreate(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadPerformanceAll(
    context: PerformanceContext,
    payload: UploadPerformanceAll
  ) {
    try {
      const response = await api.uploadPerformanceAll(
        context.rootState.main.token,
        payload
      );
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepNzmSimpleRetry(
    context: PerformanceContext,
    payload: IdeepDataCheck
  ) {
    try {
      const response = await api.deepNzmSimpleRetry(
        context.rootState.main.token,
        payload
      );
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepFlameRetry(
    context: PerformanceContext,
    payload: IdeepDataCheck
  ) {
    try {
      const response = await api.deepFlameRetry(
        context.rootState.main.token,
        payload
      );
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPerformanceTableFields(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getPerformanceTableFields(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetPerformanceTableFields(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPerformanceSelectOptions(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getPerformanceSelectOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetPerformanceSelectOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerformanceCustomVersionList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getPerformanceCustomVersionList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetPerformanceCustomVersionList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceSelectOptions(
    context: PerformanceContext,
    payload: { project: number,date?:any,game_version?:any,type?:number}
  ) {
    try {
      const response = await api.getDeepPerformanceSelectOptions(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        payload?.game_version,
        payload?.type
      );
      if (response.data) {
        commitSetDeepPerformanceSelectOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceSelectOptionsOld(
    context: PerformanceContext,
    payload: { project: number,date?:any,game_version?:any}
  ) {
    try {
      const response = await api.getDeepPerformanceSelectOptionsOld(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        payload?.game_version
      );
      if (response.data) {
        commitSetDeepPerformanceSelectOptionsOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceSelectOptionsLast(
    context: PerformanceContext,
    payload: { project: number,date:any,game_version:any}
  ) {
    try {
      const response = await api.getDeepPerformanceSelectOptionsLast(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.game_version
      );
      if (response.data) {
        commitSetDeepPerformanceSelectOptionsLast(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDateVersionList(
    context: PerformanceContext,
    payload: { project: number; report_type?: number | null }
  ) {
    try {
      const response = await api.getDateVersionList(
        context.rootState.main.token,
        payload.project,
        payload?.report_type
      );
      if (response.data) {
        commitSetDateVersion(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPerformancePageList(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      scene_id_list: number[] | [];
      device_id_list: number[] | [];
      is_valid?: any;
      game_versions: string[] | [];
      page: number | "";
      size: number | string;
      custom_versions:string
    }
  ) {
    try {
      const response = await api.getPerformancePageList(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.scene_id_list,
        payload.device_id_list,
        payload.game_versions,
        payload.page,
        payload.size,
        payload?.is_valid,
        payload.custom_versions
      );
      if (response.data) {
        commitSetPerformancePageList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerformancePageListSummary(
    context: PerformanceContext,
    payload: {
      project: number;
  date:string;
      task_record_id: any;
      scene_id_list: number[] | [];
      device_id_list: number[] | '';
      is_valid?: any;
      
      game_versions: string[] | [];
      is_deep?:number|'';
      page: number | "";
      size: number | string;
      type:any,
      subtype:any
    }
  ) {
    try {
      const response = await api.getPerformancePageListSummary(
        context.rootState.main.token,
        payload.project,
        payload.date,
      
        payload.task_record_id,
        payload.scene_id_list,
        payload.device_id_list,
        payload.game_versions,
      
        payload.page,
        payload.size,
        payload?.is_valid,
        payload?.is_deep,
        payload?.type,
        payload?.subtype,
    
      );
      if (response.data) {
        commitSetPerformancePageListSummary(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformancePageList(
    context: PerformanceContext,
    payload: {
      project: number;
      type?: number;
      
      
      scene_id_list?: number[] | [];
      device_id_list?: number[] | [];
      game_versions?: any;
      page?: number | "";
      size?: number | string;
  
    }
  ) {
    try {
      const response = await api.getDeepPerformancePageList(
        context.rootState.main.token,
        payload.project,
        payload?.type,
        payload?.scene_id_list,
        payload?.device_id_list,
        payload?.game_versions,
        payload?.page,
        payload?.size,
      
      );
      if (response.data) {
        commitSetDeepPerformancePageList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetTestInfo(
    context: PerformanceContext,
    payload: { project: number; id: number }
  ) {
    try {
      const response = await api.getTestInfo(
        context.rootState.main.token,
        payload.project,
        payload.id
      );
      if (response.data) {
        commitSetTestInfo(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetLabelInfo(
    context: PerformanceContext,
    payload: { project: number; id_test: number }
  ) {
    try {
      const response = await api.getLabelInfo(
        context.rootState.main.token,
        payload.project,
        payload.id_test
        // payload.id_label
      );
      if (response.data) {
        commitSetLabelInfo(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetLabelInfoLabel(
    context: PerformanceContext,
    payload: { project: number; id_test: number,id_label:any }
  ) {
    try {
      const response = await api.getLabelInfoLabel(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.id_label
      );
      if (response.data) {
        commitSetLabelInfoLabel(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetperfInfo(
    context: PerformanceContext,
    payload: { id_test: number }
  ) {
    try {
      const response = await api.getperfInfo(
        context.rootState.main.token,

        payload.id_test
        // payload.id_label
      );
      if (response.data) {
        commitSetPerfInfo(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceDetails(
    context: PerformanceContext,
    payload: { project: number; id_test: number }
  ) {
    try {
      const response = await api.getDeepPerformanceDetails(
        context.rootState.main.token,
        payload.project,
        payload.id_test
        // payload.id_label
      );
      if (response.data) {
        commitSetDeepPerformanceDetails(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetCaseMonitorList(
    context: PerformanceContext,
    payload: { project: number; }
  ) {
    try {
      const response = await api.getCaseMonitorList(
        context.rootState.main.token,
        payload.project,
    
        // payload.id_label
      );
      if (response.data) {
        commitSetCaseMonitorList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetCaseMonito(
    context: PerformanceContext,
    payload: { project: number; id:number|''}
  ) {
    try {
      const response = await api.getCaseMonitor(
        context.rootState.main.token,
        payload.project,
        payload.id,
    
        // payload.id_label
      );
      if (response.data) {
        commitSetCaseMonitor(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceStack(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: number;
      frame: any | "";
      level: any | "";
      func_hash: any | "";
    }
  ) {
    try {
      const response = await api.getDeepPerformanceStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.frame,
        payload.level,
        payload.func_hash

        // payload.id_label
      );
      if (response.data) {
        commitSetDeepPerformanceStack(context, response.data);
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetNzmMemoryStack(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      depth?: number;
      name?: any;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
    }
  ) {
    try {
      const response = await api.getNzmMemoryStack(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.depth,
        payload?.name,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene

        // payload.id_label
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetNzmMemoryStackAll(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      depth?: number;
      name?: any;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
    }
  ) {
    try {
      const response = await api.getNzmMemoryStackAll(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.depth,
        payload?.name,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene

        // payload.id_label
      );
      if (response.data) {
        commitSetNzmMemoryStackAll(context, response.data);
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepMemoryData(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      date:string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      depth?: number;
      name?: any;
      old_date?:string;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
      filter?:string;
    }
  ) {
    try {
      const response = await api.deepMemoryData(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.date,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.depth,
        payload?.name,
        payload?.old_date,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene,
        payload?.filter

        // payload.id_label
      );
      if (response.data) {
        commitSetDeepMemoryData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepMemoryDataCread(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      date:string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      depth?: number;
     
      old_date?:string;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
      name?: string;
   
    }
  ) {
    try {
      const response = await api.deepMemoryStackDataCread(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.date,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.depth,
  
        payload?.old_date,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene,
        payload?.name,
    

        // payload.id_label
      );
      if (response.data) {
        commitSetDeepMemoryDataCread(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepMemoryDataCreadOld(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      date:string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      depth?: number;
    
      old_date?:string;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
      name:string
   
    }
  ) {
    try {
      const response = await api.deepMemoryStackDataCread(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.date,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.depth,
    
        payload?.old_date,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene,
        payload?.name,
    

        // payload.id_label
      );
      if (response.data) {
        commitSetDeepMemoryDataCreadOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateReport(
    context: PerformanceContext,
    payload: {
      project: number;
      new_version: string;
      old_version: string;
      timestamp: string;
      old_timestamp: string;
      report_name?: string;
      scene_list?: any;
      subtype?: number | null;
      report_type?: number | null;
    }
  ) {
    try {
      const response = await api.createReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetNewReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateReportByTask(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      old_record_id: any;
      report_name?: string;
      allow?: any;
      subtype?: number | null;
      report_type?: number | null;
      is_avg?: boolean | null | number;
      robot?:any
    }
  ) {
    try {
      const response = await api.createReportByTask(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetNewReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
      page: number;
      size: number;
      report_name: string;
      new_version: string;
      old_version: string;
      risk: string;
      creator: string;
    }
  ) {
    try {
      const response = await api.deleteReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      commitDeleteReport(context, {
        project: payload.project,
        page: payload.page,
        size: payload.size,
        report_name: payload.report_name,
        new_version: payload.new_version,
        old_version: payload.old_version,
        risk: payload.risk,
        creator: payload.creator,
      });
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPerfSecondData(
    context: PerformanceContext,
    payload: { project: number; id_test: number; id_label: string[] }
  ) {
    try {
      const response = await api.getPerfSecondData(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.id_label
      );
      if (response.data) {
        commitSetPerfSecondData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerfAvgdData(
    context: PerformanceContext,
    payload: { project: number; id_test: number; id_label: string[] }
  ) {
    try {
      const response = await api.getPerfAvgData(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.id_label
      );
      if (response.data) {
        commitSetPerfAvgdData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetPerfReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
      interval?: number | null;
      record_list?: any[] | null;
      old_record_list?: any[] | null;
      is_inside_skin?: any | null;
      report_type?:any
    }
  ) {
    try {
      const response = await api.getPerfReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
        payload?.interval,
        payload?.record_list,
        payload?.old_record_list,
        payload?.is_inside_skin,
        payload?.report_type
      );
      if (response.data) {
        commitSetPerfReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetWeaponDetail(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
     
    }
  ) {
    try {
      const response = await api.weaponDetail(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
       
      );
      if (response.data) {
        commitSetWeaponReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetLiveReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.liveReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetLiveReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetPerfIdTest(
    context: PerformanceContext,
    payload: {
      task_record_id: number;
      task_group_index: number;
      device_id: number;
    }
  ) {
    try {
      const response = await api.getPerfIdTest(
        context.rootState.main.token,
        payload.task_record_id,
        payload?.task_group_index,
        payload?.device_id
      );
      if (response.data) {
        commitSetPerfReportIdTest(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetStressPerfReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
      interval?: number | null;
      is_inside_skin?: any;
    }
  ) {
    try {
      const response = await api.getStressPerfReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
        payload?.interval,
        payload?.is_inside_skin
      );
      if (response.data) {
        commitSetStressPerfReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetLabelReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
      interval?: number | null;
      is_inside_skin?: any;
    }
  ) {
    try {
      const response = await api.getLabelReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
        payload?.interval,
        payload?.is_inside_skin
      );
      if (response.data) {
        commitSetLabelReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetPerfReportSpeedm(
    context: PerformanceContext,
    payload: { project: number; report_id: number; interval?: number | null }
  ) {
    try {
      const response = await api.getPerfReportSpeedm(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetPerfReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetPerfReportSpeedmGpu(
    context: PerformanceContext,
    payload: { project: number; report_id: number; interval?: number | null }
  ) {
    try {
      const response = await api.getPerfReportSpeedmGPU(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetPerfReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiongetNzmGpuReport(
    context: PerformanceContext,
    payload: { project: number; report_id: number; interval?: number | null }
  ) {
    try {
      const response = await api.getNzmGpuReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetNzmReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAovCopyPerfToReport(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      device_id: any;
      report_id: any;
    }
  ) {
    try {
      const response = await api.aovCopyPerfToReport(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.device_id,
        payload.report_id
      );
      if (response.data) {
        commitSetAovCopyPerfToReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetReportList(
    context: PerformanceContext,
    payload: {
      project: number;
      page: number;
      report_name: string;
      new_version: string;
      old_version: string;
      risk: string;
      creator: string;
      size: number;
    }
  ) {
    try {
      const response = await api.getReportList(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.report_name,
        payload.new_version,
        payload.old_version,
        payload.risk,
        payload.creator
      );
      if (response.data) {
        commitSetReports(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDownloadCsv(
    context: PerformanceContext,
    payload: { project: number; id_test: number }
  ) {
    try {
      const response = await api.downloadCsv(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      await api.removeCsv(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      return response.data;
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionRemoveCsv(
    context: PerformanceContext,
    payload: { project: number; id_test: number }
  ) {
    try {
      const response = await api.removeCsv(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionUploadReportImage(
    context: PerformanceContext,
    payload: IUploadReport
  ) {
    try {
      const response = await api.uploadReportImage(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadGamesReportImage(
    context: PerformanceContext,
    payload: IUploadReport
  ) {
    try {
      const response = await api.uploadGamesReportImage(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadCpuReport(
    context: PerformanceContext,
    payload: IUploadCpuReport,
  ) {
    try {
      const response = await api.uploadCpuReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
        return response.data
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadCpuReport1(
    context: PerformanceContext,
    payload: IUploadCpuReport,
  ) {
    try {
      const response = await api.uploadCpuReport1(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
        return response.data
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadPerfettoReport(
    context: PerformanceContext,
    payload: IUploadCpuReport,
  ) {
    try {
      const response = await api.uploadPerfettoReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        // ElMessage.success({
        //   message: "报告发送成功",
        //   showClose: true,
        //   type: "success",
        // });
        return response.data
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadXcodeReport(
    context: PerformanceContext,
    payload: IUploadCpuReport,
  ) {
    try {
      const response = await api.uploadXcodeReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        // ElMessage.success({
        //   message: "报告发送成功",
        //   showClose: true,
        //   type: "success",
        // });
        return response.data
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadPkgReport(
    context: PerformanceContext,
    payload: IUploadCpuReport,
  ) {
    try {
      const response = await api.uploadPkgReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionNzmUploadReportImage(
    context: PerformanceContext,
    payload: INzmUploadReport
  ) {
    try {
      const response = await api.uploadNzmReportImage(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendMemory(
    context: PerformanceContext,
    payload: IMemory
  ) {
    try {
      const response = await api.sendMemory(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadReportImageGpu(
    context: PerformanceContext,
    payload: IUploadReport
  ) {
    try {
      const response = await api.uploadSpeedmReportImageGpu(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUploadDcReportImage(
    context: PerformanceContext,
    payload: IUploadDcReportSimple
  ) {
    try {
      const response = await api.uploadDcReportImage(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendSpeedmReport(
    context: PerformanceContext,
    payload: IUploadReport
  ) {
    try {
      const response = await api.uploadSpeedmReportImage(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetReportDetail(
    context: PerformanceContext,
    payload: { project: number; id: number,}
  ) {
    try {
      const response = await api.getReportDetail(
        context.rootState.main.token,
        payload.project,
        payload.id,
       
      );
      if (response.data) {
        commitSetNewReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetReportSmgDetail(
    context: PerformanceContext,
    payload: { project: number; report_id: number,}
  ) {
    try {
      const response = await api.getReportSmgDetail(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
       
      );
      if (response.data) {
        commitSetNewSmgReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetCODMReport(
    context: PerformanceContext,
    payload: { project: number; report_id: number }
  ) {
    try {
      const response = await api.getCODMReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data && response.data.code == 1) {
        commitSetCODMReport(context, response.data.data);
      } else if (response.data) {
        ElMessage({
          //Message 消息提示
          message: response.data.message,
          showClose: true,
        });
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetCODMReportList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getCODMReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetCODMReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetNewReportList(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type?: any;
      create_date?: any | null;
      task_id?: any | null;
      subtype?: any | null;
    }
  ) {
    try {
      const response = await api.getNewReportList(
        context.rootState.main.token,
        payload.project,
        payload?.report_type,
        payload?.create_date,
        payload?.task_id,
        payload?.subtype
      );
      if (response.data) {
        commitNewReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetLiveReportList(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.getLiveReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitLiveReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteCODMReport(
    context: PerformanceContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteCODMReport(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitDeleteCODMReport(context, payload.id);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendCODMReport(
    context: PerformanceContext,
    payload: IUploadReport
  ) {
    try {
      const response = await api.sendCODMReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送成功",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateReport(context: PerformanceContext, payload: IReport) {
    try {
      const response = await api.updateReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        // commitUpdateReport(context, payload.project as number);
        commitUpdateReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateComReport(context: PerformanceContext, payload: IReport) {
    try {
      const response = await api.updateComReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        // commitUpdateReport(context, payload.project as number);
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleUpdateReport(context: PerformanceContext, payload: ISimple) {
    try {
      const response = await api.SimpleupdateReport(
        context.rootState.main.token,
        payload
      );
      // if (response.data) {
      //   // commitUpdateReport(context, payload.project as number);
      //   commitUpdateReport(context, response.data);
      // }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  // async actionPerforMance(context: PerformanceContext, payload: IMark) {
  //   try {
  //     const response = await api.performanceMake(
  //       context.rootState.main.token,
  //       payload
  //     );
  //     if (response.data) {
  //       // commitUpdateReport(context, payload.project as number);
  //       commitUpdateReport(context, response.data);
  //     }
  //   } catch (error: any) {
  //     await dispatchCheckApiError(context, error);
  //   }
  // },
  async actionPerforMance(
    context: PerformanceContext,
    payload: { data: IMark }
  ) {
    try {
      const response = await api.performanceMake(
        context.rootState.main.token,
        payload.data
      );
      // if (response.data) {
      // commitDataValid(context, payload.project);
      // }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCaseControl(
    context: PerformanceContext,
    payload: { data: IControl }
  ) {
    try {
      const response = await api.caseControl(
        context.rootState.main.token,
        payload.data
      );
      if (response.data) {
        commitCaseControl(context, response.data);
        ElMessage({
          message: response.data,
          type: "success",
        });
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateSkinLineView(
    context: PerformanceContext,
    payload: ISkinDetail
  ) {
    try {
      const response = await api.updateSkinLineView(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetUpdateSkinLineView(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCaseDetail(context: PerformanceContext, payload: ICaseDetail) {
    try {
      const response = await api.caseDetail(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage({
          message: "保存成功",
          type: "success",
        });
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCheck(context: PerformanceContext, payload: IdeepDataCheck) {
    try {
      const response = await api.deepPerformanceCheck(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
      return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformancSummaryEdit(context: PerformanceContext, payload: IdeepDataCheck) {
    try {
      const response = await api.deepPerformanceSummaryEdit(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
      return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTopTemplatesEdit(context: PerformanceContext, payload: TemplatesCreate) {
    try {
      const response = await api.topTemplatesEdit(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
      return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTopBaselinesEdit(context: PerformanceContext, payload: BaselinesCreate) {
    try {
      const response = await api.topBaselinesEdit(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
      return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerformanceDashboard(
    context: PerformanceContext,
    payload: {
      project: any;
      scene_id: number | "";
      trend_type?: any;
      start?: any;
      end?: any;
      report_type?:number;
      subtype?:number
    }
  ) {
    try {
      const response = await api.getPerformanceDashboard(
        context.rootState.main.token,
        payload.project,
        payload.scene_id,
        payload.trend_type,
        payload.start,
        payload.end,
        payload?.report_type,
        payload?.subtype
      );
      if (response.data) {
        commitSetPerfDashboard(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPerformanceAnalysis(
    context: PerformanceContext,
    payload: {
      project: number;
      game_version: any;
      scene_id: number;
      device_id: any;
    }
  ) {
    try {
      const response = await api.getPerformanceAnalysis(
        context.rootState.main.token,
        payload.project,
        payload.game_version,
        payload.scene_id,
        payload.device_id
      );
      if (response.data) {
        commitsetGetPerformanceAnalysis(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerformanceAovTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: number;
    }
  ) {
    try {
      const response = await api.getPerformanceAovTrend(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id
      );
      if (response.data) {
        commitGetPerformanceAovTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetAovPerformances(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      interval: number;
    }
  ) {
    try {
      const response = await api.getAovPerformances(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.interval
      );
      if (response.data) {
        commitGetAovPerformances(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiontaskRecordQuery(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
    }
  ) {
    try {
      const response = await api.taskRecordQuery(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id
      );
      if (response.data) {
        commitTaskRecordQuery(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actiontaskRecordDevices(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
    }
  ) {
    try {
      const response = await api.taskRecordDevices(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id
      );
      if (response.data) {
        commitTaskRecordDevices(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAovPerformanceCopy(
    context: PerformanceContext,
    payload: {
      project: number;
      from: number;
      to: number;
      device: any;
    }
  ) {
    try {
      const response = await api.aovPerformanceCopy(
        context.rootState.main.token,
        payload.project,
        payload.from,
        payload.to,
        payload.device
      );
      if (response.data) {
        commitAovPerformanceCopy(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLastRecord(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.getLastRecord(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitLastRecord(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionRecentTaskrecord(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type?: number | string;
      is_memory?:number
    }
  ) {
    try {
      const response = await api.getRecentTaskrecord(
        context.rootState.main.token,
        payload.project,
        payload?.report_type,
        payload?.is_memory
      );
      if (response.data) {
        commitRecentTaskrecord(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionPerformanceAovEmail(
    context: PerformanceContext,
    payload: IPerformanceAovEmail
  ) {
    try {
      const response = await api.getPerformanceAovEmail(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitPerformanceAovEmail(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetAllPerformance(
    context: PerformanceContext,
    payload: { project: number; is_valid: boolean | "" }
  ) {
    try {
      const response = await api.getAllPerformances(
        context.rootState.main.token,
        payload.project,
        payload.is_valid
      );
      if (response.data) {
        commitSetAllPerformances(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAccessUrl(
    context: PerformanceContext,
    payload: { project: number; report_id: number }
  ) {
    try {
      const response = await api.AccessUrl(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        ElMessage.success({
          message: "报告发送完成",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDataValid(
    context: PerformanceContext,
    payload: { id: number; project: number; data: IPerformance }
  ) {
    try {
      const response = await api.dataValid(
        context.rootState.main.token,
        payload.id,
        payload.data
      );
      // if (response.data) {
      // commitDataValid(context, payload.project);
      // }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionClearCache(
    context: PerformanceContext,
    payload: { report_id: number; project: number }
  ) {
    try {
      const response = await api.clearCache(
        context.rootState.main.token,
        payload.report_id,
        payload.project
      );
      // if (response.data) {
      // commitDataValid(context, payload.project);
      // }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetTOPReportList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getTOPReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetTOPReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetTOPReportDetail(
    context: PerformanceContext,
    payload: { project: number; id: number }
  ) {
    try {
      const response = await api.getTOPReportDetail(
        context.rootState.main.token,
        payload.project,
        payload.id
      );
      if (response.data) {
        commitSetTOPReportDetail(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetTOPReport(
    context: PerformanceContext,
    payload: { project: number; report_id: number }
  ) {
    try {
      const response = await api.getTOPReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetTOPReport(context, response.data.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTOPReportTable(
    context: PerformanceContext,
    payload: { project: number; sub_project: any; date: any; user: string }
  ) {
    try {
      const response = await api.getTOPreportTable(
        context.rootState.main.token,
        payload.project,
        payload?.sub_project,
        payload?.date,
        payload?.user
      );
      if (response.data) {
        commitSetTOPReportTable(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendTOPReport(
    context: PerformanceContext,
    payload: IUploadReportSimple
  ) {
    try {
      const response = await api.sendTOPReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告正在发送",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendSmokeReport(
    context: PerformanceContext,
    payload: IUploadSmokeReporrt
  ) {
    try {
      const response = await api.sendSmokeeport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告正在发送",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendProtocolReport(
    context: PerformanceContext,
    payload: IUploadSmokeReporrt
  ) {
    try {
      const response = await api.sendProtocolReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告正在发送",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendLoginSmokeport(
    context: PerformanceContext,
    payload: IUploadSmokeReporrt
  ) {
    try {
      const response = await api.sendLoginSmokeport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告正在发送",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateTOPReport(
    context: PerformanceContext,
    payload: ITOPReportUpload
  ) {
    try {
      const response = await api.updateTOPReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        await dispatchGetTOPReportDetail(store, {
          project: payload.project,
          id: payload.id,
        });
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTOPReportTableList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getTOPReportTableList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetTOPReportTableList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTOPReportGenerate(
    context: PerformanceContext,
    payload: {
      project: number;
      report_name: string;
      sub_project: number;
      performance_id_list: any;
    }
  ) {
    try {
      const response = await api.getTOPReportGenerate(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        commitSetTOPReportGenerate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteTOPReport(
    context: PerformanceContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteTOPReport(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteTokenList(
    context: PerformanceContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteTokenList(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteSmokeReport(
    context: PerformanceContext,
    payload: { report_id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteSmokeeport(
            context.rootState.main.token,
            payload.report_id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteProtocolReportDetail(
    context: PerformanceContext,
    payload: { report_id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteProtocolReportDetail(
            context.rootState.main.token,
            payload.report_id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteLoginSmokeport(
    context: PerformanceContext,
    payload: { report_id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteLoginSmokeport(
            context.rootState.main.token,
            payload.report_id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteInstantiation(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteInstantiation(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteSimpleData(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteSimpleData(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteAbd(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteAbd(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteFile(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteFile(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteLight(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteLight(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteOffline(
    context: PerformanceContext,
    payload: { id_test: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteOffline(
            context.rootState.main.token,
            payload.id_test,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeletetopPerformance(
    context: PerformanceContext,
    payload: {  project: number;id_list: any; }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deletetopPerformance(
            context.rootState.main.token,
            payload.project,
            payload.id_list,
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  // async actionDeleteSimpleData(
  //   context: PerformanceContext,
  //   payload: { id_test: number; project: number }
  // ) {
  //   try {
  //     const response = (
  //       await Promise.all([
  //         api.deleteSimpleData(
  //           context.rootState.main.token,
  //           payload.id_test,
  //           payload.project
  //         ),
  //         await new Promise<void>((resolve, reject) =>
  //           setTimeout(() => resolve(), 500)
  //         ),
  //       ])
  //     )[0];
  //   } catch (error) {
  //     await dispatchCheckApiError(context, error);
  //   }
  // },
  async actionGetXhookReportList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getXhookReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetXhookReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetXhookReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.getXhookReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetXhookReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSendXhookReport(
    context: PerformanceContext,
    payload: IUploadReportSimple
  ) {
    try {
      const response = await api.sendXhookReport(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        ElMessage.success({
          message: "报告正在发送",
          showClose: true,
          type: "success",
        });
      }
    } catch (error: any) {
      ElMessage({
        showClose: true,
        message: "报告发送失败,请联系管理员",
        type: "error",
      });
      await dispatchCheckApiError(context, error);
    }
  },
  async actionReportCPUMark(
    context: PerformanceContext,
    payload: IReportMarkCPU
  ) {
    try {
      const response = await api.reportCpuMark(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
        console.log(response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteXhookReport(
    context: PerformanceContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteXhookReport(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitDeleteCODMReport(context, payload.id);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetWedoReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.getWedoReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetWedoReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetInstantiation(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: number;
    }
  ) {
    try {
      const response = await api.getInstantiation(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      if (response.data) {
        commitSetInstantiation(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetInstantiations(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.getInstantiations(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetInstantiations(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.getSkinReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetSkinReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportOption(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      skin_id: any;
    }
  ) {
    try {
      const response = await api.getSkinReportOption(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.skin_id
      );
      if (response.data) {
        commitSetSkinReportOption(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportList(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
    }
  ) {
    try {
      const response = await api.getSkinReportList(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id
      );
      if (response.data) {
        commitSetSkinReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportOptionOld(
    context: PerformanceContext,
    payload: {
      project: number;
  
    }
  ) {
    try {
      const response = await api.getSkinReportOptionOld(
        context.rootState.main.token,
        payload.project,
      
      );
      if (response.data) {
        commitSetSkinReportOptionOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportWhole(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      game_version:any
    }
  ) {
    try {
      const response = await api.getSkinReportWhole(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.game_version
      );
      if (response.data) {
        commitSetSkinReportWhole(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportdata(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      device_id: number|'';
      date: string;
      version: string;
      skin_id:any
    }
  ) {
    try {
      const response = await api.getSkinReportdata(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.device_id,
        payload.date,
        payload.version,
        payload.skin_id
      );
      if (response.data) {
        commitSetSkinReportdata(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportComparedata(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: any;
      device_id: number|'';
      date: string;
      version: string;
    }
  ) {
    try {
      const response = await api.getSkinReportComparedata(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.device_id,
        payload.date,
        payload.version
      );
      if (response.data) {
        commitSetSkinReportComparedata(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSmokeReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number | "";
    }
  ) {
    try {
      const response = await api.getSmokeReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetSmokeReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProtocolReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number | "";
    }
  ) {
    try {
      const response = await api.getProtocolReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetProtocolReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetLoginSmokeReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number | "";
    }
  ) {
    try {
      const response = await api.getLoginSmokeReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetLoginSmokeReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSmokeReportList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getSmokeReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetSmokeReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProtocolList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getProtocolList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetProtocolList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetLoginSmokeReportList(
    context: PerformanceContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getLoginSmokeReportList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetLoginSmokeReportList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinReportInside(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.getSkinReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetSkinReportInside(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSmgReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
    }
  ) {
    try {
      const response = await api.getSmgReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id
      );
      if (response.data) {
        commitSetSmgReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetSkinTableReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_id: number;
      type:string;
    }
  ) {
    try {
      const response = await api.getSkinTableReport(
        context.rootState.main.token,
        payload.project,
        payload.report_id,
        payload.type
      );
      if (response.data) {
        commitSetSkinTableReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetArrange(
    context: PerformanceContext,
    payload: {
      project: number;
   
      json_str: any;
  
    }
  ) {
    try {
      const response = await api.getArrange(
        context.rootState.main.token,
        payload
        
      );
      if (response.data) {
        commitSetArrange(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetArrangeByXlsx(
    context: PerformanceContext,
    payload: IUploadskin
  ) {
    try {
      const response = await api.getArrangeByXlsx(
        context.rootState.main.token,
        payload
        
      );
      if (response.data) {
        commitSetArrange(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionChangeFPSlte(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: number;
      value: number;
      labels: any;
      mode: any;
    }
  ) {
    try {
      const response = await api.ChangeFPS(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.value,
        payload.labels,
        payload.mode
      );
      if (response.data) {
        commitSetChangeFPSlte(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionChangeFPSgte(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: number;
      value: number;
      labels: any;
      mode: any;
    }
  ) {
    try {
      const response = await api.ChangeFPS(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.value,
        payload.labels,
        payload.mode
      );
      if (response.data) {
        commitSetChangeFPSgte(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetLogDownload(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id: number;
      UUID: any;
      scene_id: number;
    }
  ) {
    try {
      const response = await api.getlogDownload(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.UUID,
        payload.scene_id
      );
      if (response.data) {
        commitSetLogDownload(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPerformanceVersion(
    context: PerformanceContext,
    payload: {
      project: number;
      version: string;
      timestamp: string | "";
    }
  ) {
    try {
      const response = await api.getPerformanceVersion(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.timestamp
      );
      if (response.data) {
        commitSetPerformanceVersion(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPlayerid(
    context: PerformanceContext,
    payload: {
      project: number;
      playerid_dst: number;
      playerid_src: number;
    }
  ) {
    try {
      const response = await api.getPlayerid(
        context.rootState.main.token,
        payload.project,
        payload.playerid_dst,
        payload.playerid_src
      );
      if (response.data) {
        commitSetPlayerid(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGeTaskList(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.getTaskList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetTaskList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionGetPlayerid1(
    context: PerformanceContext,
    payload: {
      project: number;
      playerid_dst: number;
      playerid_src: number;
    }
  ) {
    try {
      const response = await api.getPlayerid(
        context.rootState.main.token,
        payload.project,
        payload.playerid_dst,
        payload.playerid_src
      );
      if (response.data) {
        commitSetPlayerid(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDc(
    context: PerformanceContext,
    payload: {
      project: number;
      cur_version: any;
      test_time?: any;
      base_version?: any;
    }
  ) {
    try {
      const response = await api.getDc(
        context.rootState.main.token,
        payload.project,
        payload.cur_version,
        payload?.test_time,
        payload?.base_version
      );
      if (response.data) {
        commitSetDC(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDcReport(
    context: PerformanceContext,
    payload: {
      project: number;
      is_base: number;
    }
  ) {
    try {
      const response = await api.getDcReport(
        context.rootState.main.token,
        payload.project,
        payload.is_base
      );
      if (response.data) {
        commitSetDcReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepScene(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      version?: string;
      scene?: any;
      device?: any;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
    }
  ) {
    try {
      const response = await api.deepScene(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device
      );
      if (response.data) {
        if (payload.type === "object") {
          commitSetDeepScene(context, response.data);
        } else {
          commitSetDeepSceneVedio(context, response.data);
        }
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemreport(
    context: PerformanceContext,
    payload: {
      project: number;
      version: string;
      device: any;
      scene: any;
    }
  ) {
    try {
      const response = await api.deepMemreport(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.device,
        payload.scene
      );
      if (response.data) {
        commitSetDeepMemreport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.deepSceneOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetDeepSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.deepMemoryOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetMemoryOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryLlmList(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.deepMemoryLlmList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetMemoryLlmList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDateOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.deepMemoryDateOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetMemoryDateOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemorySubSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type:string
    }
  ) {
    try {
      const response = await api.deepMemorySubSceneOptions(
        context.rootState.main.token,
        payload.project,
        payload.type
        
      );
      if (response.data) {
        commitSetMemorySubSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryRecordList(
    context: PerformanceContext,
    payload: {
      project: number;
      date_version:any,
      device_id:any,
      scene_id:any,
      sub_scene:any,
      size:number,
      page:number,
      type:string
    }
  ) {
    try {
      const response = await api.deepMemoryRecordList(
        context.rootState.main.token,
        payload.project,
        payload.date_version,
        payload.device_id,
        payload.scene_id,
        payload.sub_scene,
        payload.size,
        payload.page,
        payload.type,
      );
      if (response.data) {
        commitSetMemoryRecordList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id:number;
      scene_id:number;
      type:string;
      start:string;
      end:string

    }
  ) {
    try {
      const response = await api.deepMemoryTrend(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.type,
        payload.start,
        payload.end,
      );
      if (response.data) {
        commitSetMemoryTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemorySceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id:any
    }
  ) {
    try {
      const response = await api.deepMemorySceneOptions(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
      );
      if (response.data) {
        commitSetMemorySceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDownLoad(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      old_test:number
   
    },
  
  ) {
    try {
      const response = await api.deepMemoryDownLoad(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
       
      )
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepTopDownLoad(
    context: PerformanceContext,
    payload: {
      project: number|'';
      label:any;
      model:any;
      level:any;
      tester:any
      project_name:any
      id_list?:any
      id_test?:any
      label_main?:any
    },
  
  ) {
    try {
      const response = await api.deepTopDownLoad(
        context.rootState.main.token,
        payload.project,
        payload.label,
        payload.model,
        payload.level,
        payload.tester,
        payload.project_name,
        payload.id_list,
        payload.id_test,
        payload.label_main,
      )
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryReport(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id:number;
      version:string
    }
  ) {
    try {
      const response = await api.deepMemoryReport(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.version
      );
      if (response.data) {
        commitSetMemoryReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepUnityMemoryReport(
    context: PerformanceContext,
    payload: {
      project: number;
      task_record_id:number;
      version:string
    }
  ) {
    try {
      const response = await api.deepUnityMemoryReport(
        context.rootState.main.token,
        payload.project,
        payload.task_record_id,
        payload.version
      );
      if (response.data) {
        commitSetUnityMemoryReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepUnityMemoryList(
    context: PerformanceContext,
    payload: {
      project: number;
      old_test:number|'',
      id_test:number,
      page:number,
      size:number,
      search:string,
      reverse:number
    }
  ) {
    try {
      const response = await api.deepUnityMemoryList(
        context.rootState.main.token,
        payload.project,
        payload.old_test,
        payload.id_test,
        payload.page,
        payload.size,
        payload.search,
        payload.reverse,
        
      );
      if (response.data) {
        commitSetUnityMemoryList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryCircleChart(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      device_id:number
      scene_id:number
      sub_scene:string
      version:string
      old_date:string
      old_device_id:number
      old_scene_id:number
      old_sub_scene:string
      old_version:string,
      type:string,
    }
  ) {
    try {
      const response = await api.deepMemoryCircleChart(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.sub_scene,
        payload.version,
        payload.old_date,
        payload.old_device_id,
        payload.old_scene_id,
        payload.old_sub_scene,
        payload.old_version,
        payload.type
      );
      if (response.data) {
        commitSetMemoryCircleChar(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryUobject(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      device_id:number
      scene_id:number
      sub_scene:string
      version:string
      old_date:string
      old_device_id:number
      old_scene_id:number
      old_sub_scene:string
      old_version:string,

    }
  ) {
    try {
      const response = await api.deepMemoryUobject(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.sub_scene,
        payload.version,
        payload.old_date,
        payload.old_device_id,
        payload.old_scene_id,
        payload.old_sub_scene,
        payload.old_version,
   
      );
      if (response.data) {
        commitSetMemoryUobject(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryUobjectTrend(
    context: PerformanceContext,
    payload: {
      project: number;
    
      device_id:number
      scene_id:number
    

    }
  ) {
    try {
      const response = await api.deepMemoryUobjectTrend(
        context.rootState.main.token,
        payload.project,
       
        payload.device_id,
        payload.scene_id,
       
   
      );
      if (response.data) {
        commitSetMemoryUobjectTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDate(
    context: PerformanceContext,
    payload: {
      project: number;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDate(
        context.rootState.main.token,
        payload.project,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryVersion(
    context: PerformanceContext,
    payload: {
      project: number;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryVersion(
        context.rootState.main.token,
        payload.project,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryVersion(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDevice(
    context: PerformanceContext,
    payload: {
      project: number;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDevice(
        context.rootState.main.token,
        payload.project,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDeviceSecond(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type:any,date:any,version:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDeviceSecond(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.date,
        payload.version,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDeviceSecond(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryScene(
    context: PerformanceContext,
    payload: {
      project: number;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryScene(
        context.rootState.main.token,
        payload.project,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryScene(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryType(
    context: PerformanceContext,
    payload: {
      project: number;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryType(
        context.rootState.main.token,
        payload.project,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryType(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDateVersion(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type?: any;
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDateVersion(
        context.rootState.main.token,
        payload.project,
        payload?.report_type,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDateVersion(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDateVersionNew(
    context: PerformanceContext,
    payload: {
      project: number;
  
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDateVersion(
        context.rootState.main.token,
        payload.project,
      
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDateVersionNew(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepMemoryDateVersionDevice(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id:any
  
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDateVersionDevice(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
      
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryDateVersionDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryLevel(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      date:any,version:any,device_id:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryLevel(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemoryLevel(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemorySceneSecond(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      date:any,version:any,device_id:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorySceneSecond(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemorySceneSecond(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemorymoduleAll(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      date:any,version:any,device_id:any
      scene_name:any,level:any,top:any,search:any,old_date:any,old_version:any,
      order_by:any;
      reverse:any;
     

    }
  ) {
    try {
      const response = await api.ObjectMemorymoduleAll(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
        payload.scene_name,
        payload.level,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemorymoduleAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryReport(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      date:any,version:any,device_id:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryReport(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemoryReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryTrend(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemoryTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any;scene_name:any
      device_id:any,date:any,version:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionTrend(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
        payload.scene_name,
        payload.device_id,
        payload.date,
        payload.version,
       
     
       
   
      );
      if (response.data) {
        commitSetObjectFunctionTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionId(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionId(
        context.rootState.main.token,
        payload.project,
        payload.id,
      
       
     
       
   
      );
      if (response.data) {
        commitSetObjectFunctionId(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryModuleListId(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleListId(
        context.rootState.main.token,
        payload.project,
        payload.id,
      
       
     
       
   
      );
      if (response.data) {
        commitSetObjectMemoryModuleListId(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryFileName(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryFileName(
        context.rootState.main.token,
        payload.project,
        payload.id,
      
       
     
       
   
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryDownLoad(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any,old_id:any,func:any,module:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryDownLoad(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.old_id,
        payload.func,
        payload.module,
      
       
     
       
   
      );
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionTrendDraw(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any;scene_name:any;func_list:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionTrendDraw(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
        payload.scene_name,
        payload.func_list,
        
       
     
       
   
      );
      if (response.data) {
        commitSetObjectFunctionTrendDraw(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryList(
    context: PerformanceContext,
    payload: {
      project: number;
     
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryList(
        context.rootState.main.token,
        payload.project,
     
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryListData(
    context: PerformanceContext,
    payload: {
      project: number;
      date_list:any
     
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryListData(
        context.rootState.main.token,
        payload.project,
        payload.date_list,
     
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryListData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryStack(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemorySubStack(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemorySubStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryAllStack(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryAllStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryAppointStack(
    context: PerformanceContext,
    payload: {
      project: number,module:string,func:string,size:any,
      date:any,
      version:any,
      device_id:any
      report_type:any,
      scene_name:any
      level:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorNoStack(
        context.rootState.main.token,
        payload.project,
       
        payload.module,
        payload.func,
        payload.size,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.level,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryAppointStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryAppointOldLeftStack(
    context: PerformanceContext,
    payload: {
      project: number,module:string,func:string,size:any,
      date:any,
      version:any,
      device_id:any
      report_type:any,
      scene_name:any
      level:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorNoStack(
        context.rootState.main.token,
        payload.project,
       
        payload.module,
        payload.func,
        payload.size,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.level,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryAppointOldLeftStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryAppointOldRightStack(
    context: PerformanceContext,
    payload: {
      project: number,module:string,func:string,size:any,
      date:any,
      version:any,
      device_id:any
      report_type:any,
      scene_name:any
      level:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorNoStack(
        context.rootState.main.token,
        payload.project,
       
        payload.module,
        payload.func,
        payload.size,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.level,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryAppointOldRightStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryAllStackOld(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryAllStackOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemorySubStackOld(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemorySubStackOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectMemoryStackOld(
    context: PerformanceContext,
    payload: {
      project: number,id:string,module:string,func:string,size:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemorStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.module,
        payload.func,
        payload.size,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryStackOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleList(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleList(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryModuleList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionTrendAll(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any;scene_name:any
      device_id:any,date:any,version:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionTrend(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
        payload.scene_name,
        payload.device_id,
        payload.date,
        payload.version,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryFunctionTrendAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionAppoint(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any;scene_name:any
      device_id:any,date:any,version:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionTrend(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
        payload.scene_name,
        payload.device_id,
        payload.date,
        payload.version,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryFunctionAppoint(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFunctionAppointOld(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type: any;
      level:any,start:any,end:any;scene_name:any
      device_id:any,date:any,version:any
    
     

    }
  ) {
    try {
      const response = await api.ObjectFunctionTrend(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.level,
        payload.start,
        payload.end,
        payload.scene_name,
        payload.device_id,
        payload.date,
        payload.version,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryFunctionAppointOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleListSecond(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string;level:any;report_type:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleListSecond(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
        payload.level,
        payload.report_type,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryModuleListSecond(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleListAppoint(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string;level:any;report_type:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleListSecond(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
        payload.level,
        payload.report_type,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryModuleListAppoint(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleListAppointOld(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string;level:any;report_type:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleListSecond(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
        payload.level,
        payload.report_type,
       
     
       
   
      );
      if (response.data) {
        commitSetMemoryModuleListAppointOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string,modules:string
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
        payload.modules,
       
     
       
   
      );
      if (response.data) {
        commitSetMemorModuleTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectModuleSubTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,end:string,device_id:string,scene_name:string,modules:string,report_type:any,level:any
     

    }
  ) {
    try {
      const response = await api.ObjectMemoryModuleSubTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_name,
        payload.modules,
        payload.report_type,
        payload.level,
       
     
       
   
      );
      if (response.data) {
        commitSetMemorModuleSubTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemreportData(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      device_id:number
      scene_id:number
      sub_scene:string
      version:string
      old_date:string
      old_device_id:number
      old_scene_id:number
      old_sub_scene:string
      old_version:string
      class_name:string,
      search:string,
      page:any,
      size:any,
      order:string
    }
  ) {
    try {
      const response = await api.deepMemreportData(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.sub_scene,
        payload.version,
        payload.old_date,
        payload.old_device_id,
        payload.old_scene_id,
        payload.old_sub_scene,
        payload.old_version,
        payload.class_name,
        payload.search,
        payload.page,
        payload.size,
        payload.order
      );
      if (response.data) {
        commitSetMemreportData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSkinManagement(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.skinManagement(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetSkinManagement(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSgameSkinOption(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.sgameSkinOption(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetSgameSkinOption(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSgameSkinData(
    context: PerformanceContext,
    payload: {
      project: number;
      skin_tab_id:any,
    }
  ) {
    try {
      const response = await api.sgameSkinData(
        context.rootState.main.token,
        payload.project,
        payload.skin_tab_id
      );
      if (response.data) {
        commitSetSgameSkinData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSkinTabListGet(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.sgameSkinTabListGet(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetSkinTabListGet(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSgameSkinTabList(
    context: PerformanceContext,
    payload: {
      project: number,tab_name:string,start_date:any,end_date:any,skin_list:any

    }
  ) {
    try {
      const response = await api.sgameSkinTabList(
        context.rootState.main.token,
        payload
      );
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSkinLinePkg(
    context: PerformanceContext,
    payload: {
      project: number;
      date: string;
    }
  ) {
    try {
      const response = await api.skinLinePkg(
        context.rootState.main.token,
        payload.project,
        payload.date
      );
      if (response.data) {
        commitSetSkinLinePkg(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSkinLineDate(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.skinLineDate(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetSkinLineDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTestCase(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.testCase(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSetTestCase(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTestCaseList(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.testCaseList(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        response.data.forEach(item=>
          item.params = item.params ? JSON.parse(item.params) : {}
          )
        commitSetTestCaseList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleDateOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.simpleDateOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSimpleDateOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfDate(
    context: PerformanceContext,
    payload: {
      project: number;
      data_type:string
    }
  ) {
    try {
      const response = await api.lightPerfDate(
        context.rootState.main.token,
        payload.project,
        payload.data_type
      );
      if (response.data) {
        commitLightPerfDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppDate(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.androidAppDate(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitAndroidAppDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfDateContrast(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id:number;
      scene_id:number;
      subtype:number;
      data_type:string;
    }
  ) {
    try {
      const response = await api.lightPerfDateContrast(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
        payload.data_type
      );
      if (response.data) {
        commitLightPerfDateContrast(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppDateContrast(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id:number;
      scene_id:number;
      subtype:number;
    }
  ) {
    try {
      const response = await api.androidAppDateContrast(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.subtype
      );
      if (response.data) {
        commitAndroidAppDateContrast(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      functions:any
      data_type:string
    }
  ) {
    try {
      const response = await api.lightPerfTrend(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.functions,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppFileTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      file_name:any
    }
  ) {
    try {
      const response = await api.androidAppFileTrend(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.file_name,
      );
      if (response.data) {
        commitAndroidAppFileTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfResourceCost(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any
      data_type:string
    }
  ) {
    try {
      const response = await api.lightPerfResourceCost(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfResourceCost(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppFileCompare(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any
    }
  ) {
    try {
      const response = await api.androidAppFileCompare(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
      );
      if (response.data) {
        commitAndroidAppFileCompare(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfJankCost(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any
      data_type?:string
    }
  ) {
    try {
      const response = await api.lightPerfJankCost(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
        payload?.data_type,
      );
      if (response.data) {
        commitLightPerfJankCost(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfMethodCost(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any
      data_type?:string
    }
  ) {
    try {
      const response = await api.lightPerfMethodCost(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
        payload?.data_type,
      );
      if (response.data) {
        commitLightPerfMethodCost(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfFunctions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      data_type:string
    }
  ) {
    try {
      const response = await api.lightPerfFunctions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfFunctions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfUrl(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
    }
  ) {
    try {
      const response = await api.lightPerfUrl(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      if (response.data) {
        commitLightPerfUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppFilename(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
    }
  ) {
    try {
      const response = await api.androidAppFilename(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      if (response.data) {
        commitAndroidAppFilename(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppFileUrl(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
    }
  ) {
    try {
      const response = await api.androidAppFileUrl(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      if (response.data) {
        commitAndroidAppFileUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfDevice(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      data_type:string;
    }
  ) {
    try {
      const response = await api.lightPerfDevice(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.data_type
      );
      if (response.data) {
        commitLightPerfDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppDevice(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
    }
  ) {
    try {
      const response = await api.androidAppDevice(
        context.rootState.main.token,
        payload.project,
        payload.date
      );
      if (response.data) {
        commitAndroidAppDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppZip(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test :number;
    }
  ) {
    try {
      const response = await api.androidAppZip(
        context.rootState.main.token,
        payload.project,
        payload.id_test
      );
      if (response.data) {
        commitAndroidAppZip(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfScene(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      data_type:string
      
    }
  ) {
    try {
      const response = await api.lightPerfScene(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfScene(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppScene(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      
    }
  ) {
    try {
      const response = await api.androidAppScene(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
      );
      if (response.data) {
        commitAndroidAppScene(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSubtype(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      data_type:string;
    }
  ) {
    try {
      const response = await api.lightPerfSubtype(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfSubtype(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppSubtype(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
    }
  ) {
    try {
      const response = await api.androidAppSubtype(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
      );
      if (response.data) {
        commitAndroidAppSubtype(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightLog(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      subtype:number;
      data_type:string;
    }
  ) {
    try {
      const response = await api.lightPerfLog(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
        payload.data_type,
      );
      if (response.data) {
        commitLightPerfLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppLog(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      subtype:number;
    }
  ) {
    try {
      const response = await api.androidAppLog(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
      );
      if (response.data) {
        commitAndroidAppLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdDateOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.abdDateOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitAbdDateOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceDate(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.pkgResourceDate(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitPkgResourceDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceDevice(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
    }
  ) {
    try {
      const response = await api.pkgResourceDevice(
        context.rootState.main.token,
        payload.project,
        payload.date,
      );
      if (response.data) {
        commitPkgResourceDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceScenes(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      device_id:number
    }
  ) {
    try {
      const response = await api.pkgResourceScenes(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
      );
      if (response.data) {
        commitPkgResourceScenes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceList(
    context: PerformanceContext,
    payload: {
      project: number;
      date?:string
      // device_id:number
      // scene_id:number
    }
  ) {
    try {
      const response = await api.pkgResourceList(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        // payload.device_id,
        // payload.scene_id,
      );
      if (response.data) {
        commitPkgResourceList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceReport(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      old_test:number;
    }
  ) {
    try {
      const response = await api.pkgResourceReport(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
      
      );
      if (response.data) {
        commitPkgResourceReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceAbnormalList(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      page:any;
      size:any;
      search:any,
      type:any
      is_ignore:any
    }
  ) {
    try {
      const response = await api.pkgResourceAbnormalList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.page,
        payload.size,
        payload.search,
        payload.type,
        payload.is_ignore,
      
      );
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceAbnormalFile(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
    
      type:any;
      is_ignore:any
    }
  ) {
    try {
      const response = await api.pkgResourceAbnormalFile(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
        payload.type,
        payload.is_ignore,
      
      );
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceListOld(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      // device_id:number
      // scene_id:number
    }
  ) {
    try {
      const response = await api.pkgResourceList1(
        context.rootState.main.token,
        payload.project,
        payload.date,
        // payload.device_id,
        // payload.scene_id,
      );
      if (response.data) {
        commitPkgResourceListOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgResourceListThreadOld(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
      // device_id:number
      // scene_id:number
    }
  ) {
    try {
      const response = await api.pkgResourceList1(
        context.rootState.main.token,
        payload.project,
        payload.date,
        // payload.device_id,
        // payload.scene_id,
      );
      if (response.data) {
        commitPkgResourceListThreadOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionResourceStack(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number
      id_row?:number|string;
      depth?:number|string
    }
  ) {
    try {
      const response = await api.pkgResourceStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload?.id_row,
        payload?.depth,
      )
      if (response.data) {
        commitPkgTypeList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionResourceSum(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number
  
    }
  ) {
    try {
      const response = await api.pkgResourceSum(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
      )
      if (response.data) {
        commitPkgResourceSum(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionResourceTrend(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      names:any;
      id_row:any;
      start:any;
      end:any
  
    }
  ) {
    try {
      const response = await api.pkgResourceTrend(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.names,
        payload.id_row,
        payload.start,
        payload.end,

     
      )
      if (response.data) {
        commitPkgResourceTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAssetTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      start:any;
      end:any
  
    }
  ) {
    try {
      const response = await api.pkgAssetTrend(
        context.rootState.main.token,
        payload.project,
      
        payload.start,
        payload.end,

     
      )
      if (response.data) {
        commitPkgAssetTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionStructTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      start:any;
      end:any
  
    }
  ) {
    try {
      const response = await api.pkgStructTrend(
        context.rootState.main.token,
        payload.project,
      
        payload.start,
        payload.end,

     
      )
      if (response.data) {
        commitPkgStructTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbnormalTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      start:any;
      end:any
  
    }
  ) {
    try {
      const response = await api.pkgabnormalTrend(
        context.rootState.main.token,
        payload.project,
      
        payload.start,
        payload.end,

     
      )
      if (response.data) {
        commitPkgAbnormalTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMapStructTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      start:any;
      end:any;
      filename:string
  
    }
  ) {
    try {
      const response = await api.pkgMapStructTrend(
        context.rootState.main.token,
        payload.project,
      
        payload.start,
        payload.end,
        payload.filename,

     
      )
      if (response.data) {
        commitPkgMapStructTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuLabels(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
      id_test:any
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuLabels(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
        payload.id_test,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuLabels(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuUsageTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
      is_auto:any,
      type:any,
      subtype:any
     
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuUsageTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
           payload.is_auto,
        payload.type,
        payload.subtype,
       
     
      )
      if (response.data) {
        commitDeepPerformanceCpuUsageTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuLabelsOld(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any,
      version:any,
      device_id:number,
      scene_id:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuLabelsOld(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.version,
        payload.device_id,
        payload.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuLabelsOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuPerfTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      device_id:number,
      scene_id:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuPerfTrend(
        context.rootState.main.token,
        payload.project,
   
        payload.device_id,
        payload.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuPerfTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuCustomTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      device_id:number,
      scene_id:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuCustomTrend(
        context.rootState.main.token,
        payload.project,
   
        payload.device_id,
        payload.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuCustomTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuVersions(
    context: PerformanceContext,
    payload: {
      project: number;
      is_auto:any,
      type:any,
      subtype:any
      device_id?:any,
      scene_id?:any
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuVersions(
        context.rootState.main.token,
        payload.project,
        payload.is_auto,
        payload.type,
        payload.subtype,
        payload?.device_id,
        payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuVersions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpufuncTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      name:string
      is_auto:any,
      type:any,
      subtype:any
      device_id?:any,
      scene_id?:any
      thread?:any
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpufuncTrend(
        context.rootState.main.token,
        payload.project,
        payload.name,
        payload.is_auto,
        payload.type,
        payload.subtype,
        payload?.device_id,
        payload?.scene_id,
        payload?.thread,
     
      )
      if (response.data) {
        commitDeepPerformanceCpufuncTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuConfig(
    context: PerformanceContext,
    payload: {
      project: number;
     
      // device_id?:number,
      // scene_id?:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuConfig(
        context.rootState.main.token,
        payload.project,
        // payload?.device_id,
        // payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuConfig(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuConfigSoList(
    context: PerformanceContext,
    payload: {
      project: number;
       id_test:any
      // device_id?:number,
      // scene_id?:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuConfigSoList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        // payload?.device_id,
        // payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuConfigSoList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFunctionCos(
    context: PerformanceContext,
    payload: {
      project: number;
      thread:any;
      id_test:any
     
      // device_id?:number,
      // scene_id?:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFunctionCos(
        context.rootState.main.token,
        payload.project,
        payload.thread,
        payload.id_test,
        // payload?.device_id,
        // payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuFunctionCos(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceTrendNode(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:any;
      node_id:any
      thread?:any
     
      // device_id?:number,
      // scene_id?:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceTrendNode(
        context.rootState.main.token,
        payload.project,
  
        payload.id_test,
        payload.node_id,
        payload?.thread,
        // payload?.device_id,
        // payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceTrendNode(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFunctionModel(
    context: PerformanceContext,
    payload: {
      project: number;
      threads:any,
      sos:any,
      id_test:any
      // device_id?:number,
      // scene_id?:number
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFunctionModel(
        context.rootState.main.token,
        payload.project,
        payload.threads,
        payload.sos,
        payload.id_test,
        // payload?.device_id,
        // payload?.scene_id,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuFunctionModel(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuStack(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:any;
     frame:number;
     thread:any;
  

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuStack(
        context.rootState.main.token,
        payload.project,
        payload?.id_test,
        payload?.frame,
        payload?.thread,
     
        

     
      )
      if (response.data) {
        commitDeepPerformanceCpuStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuStackMerge(
    context: PerformanceContext,
    payload: ICpuStackMerge
  ) {
    try {
      const response = await api.deepPerformanceCpuStackMerge(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        commitDeepPerformanceCpuStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuReportText(
    context: PerformanceContext,
    payload: {
      project:number,
      id_test:any,
      old_test:any,
      risk:string,
      text:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuReportText(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceFrameProblem(
    context: PerformanceContext,
    payload: {
      project:number,
      id_test:any,
   
      thread:any,
      timelines:any,
     
      start_time:any,
      end_time:any
    }
  ) {
    try {
      const response = await api.deepPerformanceFrameProblem(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        commitDeepPerformanceFrameProblem(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformancCatonCreateList(
    context: PerformanceContext,
    payload: {
      project:number,
      start_time:any,
   
      index:any,
      id_test:any,
      end_time:any,
      end_index:any
      max_frame_index:any
      max_frame_time:any
      caton_id:any
      frame_time:any
      old_test:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCatonCreateList(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
       return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceAvgStack(
    context: PerformanceContext,
    payload: {
      project:number,
      id_test:any,
   
   
    }
  ) {
    try {
      const response = await api.deepPerformanceAvgStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test
     
        

     
      )
      if (response.data) {
        commitDeepPerformanceAvgStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTokenLibraryCreate(
    context: PerformanceContext,
    payload: {
      project:number,
     
      token:string,
      expiration_time:string
    }
  ) {
    try {
      const response = await api.tokenLibraryCreate(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoText(
    context: PerformanceContext,
    payload: {
      project:number,
     task_record_id:number,
      device_id:number,
    
      text:any
    }
  ) {
    try {
      const response = await api.perfettoText(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightPerfEditLog(
    context: PerformanceContext,
    payload: EditLog
  ) {
    try {
      const response = await api.lightPerfEditLog(
        context.rootState.main.token,
        payload
     
        

     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuStackFind(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number;
     frame:number;
     thread:any;
     abs_time:any;
     name:string

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuStackFind(
        context.rootState.main.token,
        payload.project,
        payload?.id_test,
        payload?.frame,
        payload?.thread,
        payload?.abs_time,
        payload?.name,
        

     
      )
      if (response.data) {
        commitDeepPerformanceCpuStackFind(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTokenLibraryList(
    context: PerformanceContext,
    payload: {
      project: number;
   
    

  
    }
  ) {
    try {
      const response = await api.tokenLibraryList(
        context.rootState.main.token,
        payload.project,
   
        

     
      )
      if (response.data) {
        commitTokenLibraryList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuStackCreated(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number;
     frame:number;
     depth:number
    
     id_row:any
    thread:any,
    abs_time:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuStackCreated(
        context.rootState.main.token,
        payload.project,
        payload?.id_test,
        payload?.frame,
        payload?.depth,
        payload?.id_row,
        payload?.thread,
        payload?.abs_time,

     
      )
      if (response.data) {
        commitDeepPerformanceCpuStackCreated(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuStackCreatedOld(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number;
     frame:number;
     depth:number
    
     id_row:number
    thread:any,
    abs_time:any,
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuStackCreatedOld(
        context.rootState.main.token,
        payload.project,
        payload?.id_test,
        payload?.frame,
        payload?.depth,
        payload?.id_row,
        payload?.thread,
        payload?.abs_time,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuStackCreatedOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuDetail(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:any;
  
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuDetail(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
     
      )
      if (response.data) {
        commitDeepPerformanceCpuDetail(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCputhreadByFrame(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:any;
  
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCputhreadByFrame(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
     
      )
      if (response.data) {
        commitDeepPerformanceCputhreadByFrame(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCatonList(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:any;
  
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCatonList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
     
      )
      if (response.data) {
        commitDeepPerformanceCatonList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCatonCheck(
    context: PerformanceContext,
    payload: {
      project: number;
      start_time:any;
      device_id:any;
      scene_id:any;
      end_time:any
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCatonCheck(
        context.rootState.main.token,
        payload.project,
        payload.start_time,
        payload.device_id,
        payload.scene_id,
        payload.end_time,
     
     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineDate(
    context: PerformanceContext,
    payload: {
      project: number;
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineDate(
        context.rootState.main.token,
        payload.project,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type:any
      is_all:any
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoOptions(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoTypeOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      is_all: any;

   
  
  
    }
  ) {
    try {
      const response = await api.perfettoTypeOptions(
        context.rootState.main.token,
        payload.project,
        payload.is_all,
     
       
     
     
      )
      if (response.data) {
        commitPerfettoTypeOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeTypeOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeTypeOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
     
       
     
     
      )
      if (response.data) {
        commitXcodeTypeOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeDateOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;
      report_type:any

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeDateOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.report_type,
     
       
     
     
      )
      if (response.data) {
        commitXcodeDateOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeDeviceOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;
      report_type:any
      date:any;
      version:any

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeDeviceOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.report_type,
        payload.date,
        payload.version,
     
       
     
     
      )
      if (response.data) {
        commitXcodeDeviceOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeDimensOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;
      report_type:any
      date:any;
      version:any
      device_id:any

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeDimensionsOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
     
       
     
     
      )
      if (response.data) {
        commitXcodeDimensOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeLevelOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;
      report_type:any
      date:any;
      version:any
      device_id:any
 

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeLevelOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
       
     
       
     
     
      )
      if (response.data) {
        commitXcodeLevelOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      type: any;
      report_type:any
      date:any;
      version:any
      device_id:any
     

   
  
  
    }
  ) {
    try {
      const response = await api.xcodeSceneOptions(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.report_type,
        payload.date,
        payload.version,
        payload.device_id,
       
     
       
     
     
      )
      if (response.data) {
        commitXcodeSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoSettings(
    context: PerformanceContext,
    payload: {
      project: number;
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoSettings(
        context.rootState.main.token,
        payload.project,
       
     
     
      )
      if (response.data) {
        commitPerfettoSettings(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerformanceSvgLog(
    context: PerformanceContext,
    payload: {
      project: number;
   
  
  
    }
  ) {
    try {
      const response = await api.performanceSvgLog(
        context.rootState.main.token,
        payload.project,
       
     
     
      )
      if (response.data) {
        commitPerformanceSvgLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerformanceDsLog(
    context: PerformanceContext,
    payload: {
      project: number;
   
  
  
    }
  ) {
    try {
      const response = await api.performanceDsLog(
        context.rootState.main.token,
        payload.project,
       
     
     
      )
      if (response.data) {
        commitPerformanceDsLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerformanceSvgLogData(
    context: PerformanceContext,
    payload: {
      project: number;
      id: any;
      page: any;
      size: any;
   
  
  
    }
  ) {
    try {
      const response = await api.performanceSvgLogData(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.page,
        payload.size,
       
     
     
      )
      if (response.data) {
        commitPerformanceSvgLogData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerformanceDsLogData(
    context: PerformanceContext,
    payload: {
      project: number;
      id: any;
      page: any;
      size: any;
   
  
  
    }
  ) {
    try {
      const response = await api.performanceDsLogData(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.page,
        payload.size,
       
     
     
      )
      if (response.data) {
        commitPerformanceDsLogData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoOptionsOld(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type:any
      is_all:any
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoOptions(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoOptionsOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoOldOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      report_type:any
      is_all:any;
      device_id:any
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoOldOptions(
        context.rootState.main.token,
        payload.project,
        payload.report_type,
        payload.is_all,
        payload.device_id,
       
     
     
      )
      if (response.data) {
        commitPerfettoOldOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoDownLoadStack(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any,old_id,func:any,so:any
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoDownLoadStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.old_id,
        payload.func,
        payload.so,
       
     
     
      )
      if (response.data) {
        
        return response.data
        // commitPerfettoDownLoadStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoDownLoadDimensionStack(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any,old_id,func:any,so:any
      dimension:any
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoDownLoadDimensionStack(
        context.rootState.main.token,
        payload.project,
        payload.id,
        payload.old_id,
        payload.func,
        payload.so,
        payload.dimension,
       
     
     
      )
      if (response.data) {
        
        return response.data
        // commitPerfettoDownLoadStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoFileName(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any,
   
  
  
    }
  ) {
    try {
      const response = await api.perfettoFileName(
        context.rootState.main.token,
        payload.project,
        payload.id,
    
       
     
     
      )
      if (response.data) {
        
        return response.data
        // commitPerfettoDownLoadStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeFileName(
    context: PerformanceContext,
    payload: {
      project: number;
      id:any,
   
  
  
    }
  ) {
    try {
      const response = await api.xcodeFileName(
        context.rootState.main.token,
        payload.project,
        payload.id,
    
       
     
     
      )
      if (response.data) {
        
        return response.data
        // commitPerfettoDownLoadStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoDeviceOptions(
    context: PerformanceContext,
    payload: {
      project: number;
   
      date:string;
      version:string;
      report_type:any;
      is_all:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoDeviceOptions(
        context.rootState.main.token,
        payload.project,
       

        payload.date,
        payload.version,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoDeviceOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoDeviceOptionsTrend(
    context: PerformanceContext,
    payload: {
      project: number;

      date:string;
      version:string
      report_type:any
      is_all:any
  
    }
  ) {
    try {
      const response = await api.perfettoDeviceOptions(
        context.rootState.main.token,
        payload.project,

        payload.date,
        payload.version,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoDeviceOptionsTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoDeviceOptionsImportant(
    context: PerformanceContext,
    payload: {
      project: number;

      date:string;
      version:string
      report_type:any
      is_all:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoDeviceOptions(
        context.rootState.main.token,
        payload.project,

        payload.date,
        payload.version,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoDeviceOptionsImportant(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoLevelOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      version:string
      device_id:any;
      report_type:any
      is_all:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoLevelOptions(
        context.rootState.main.token,
        payload.project,
       
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoLevelOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoStack(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any;
      is_all:any;
  
  
    }
  ) {
    try {
      const response = await api.perfettoStack(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeStack(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any;
      size:any
      so:any
      func:any
      type:any;
      dimension:any
      option:any
  
    }
  ) {
    try {
      const response = await api.xcodeStack(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.size,
        payload.so,
        payload.func,
        payload.type,
        payload.dimension,
        payload.option,
       
     
     
      )
      if (response.data) {
        commitXcodeStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoStackSearch(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any
      size:any
      so:any
      func:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoStackSearch(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.size,
        payload.so,
        payload.func,
       
     
     
      )
      if (response.data) {
        commitPerfettoStackSearch(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoStackSearchV2(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any
      size:any
      so:any
      func:any
      old_date:any
      old_version:any
      is_all:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoStackSearch_v2(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        payload.size,
        payload.so,
        payload.func,
        payload.old_date,
        payload.old_version,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoStackSearchV2(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoStackSearchFuncitons(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any
     
      func:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoStackSearchFuncitons(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
        
        payload.func,
       
     
     
      )
      if (response.data) {
        commitPerfettoStackSearchFuncitons(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoStackSearchSo(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any
      date:string;
      version:string
      device_id:any;
      report_type:any
      scene_name:any
    
      so:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoStackSearchSo(
        context.rootState.main.token,
        payload.project,
        payload.level,
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.scene_name,
     
        payload.so,
  
       
     
     
      )
      if (response.data) {
        commitPerfettoStackSearchSo(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoTraces(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any;
      version:any
      device_id:any;
      scene_name:any;
      level:any;
      
  
  
    }
  ) {
    try {
      const response = await api.perfettoTraces(
        context.rootState.main.token,
        payload.project,
       
        payload.date,
        payload.version,
        payload.device_id,
        payload.scene_name,
        payload.level,
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoLevelOptionsImportant(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      version:string
      device_id:any;
      report_type:any;
      is_all:any;
      
  
  
    }
  ) {
    try {
      const response = await api.perfettoLevelOptions(
        context.rootState.main.token,
        payload.project,
       
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoLevelOptionsImportant(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      version:string
      device_id:any
      report_type:any
      is_all:any
     
  
    }
  ) {
    try {
      const response = await api.perfettoSceneOptions(
        context.rootState.main.token,
        payload.project,
       
        payload.date,
        payload.version,
        payload.device_id,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettNativeTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      
      report_type:number|'';
      start:any
      end:any
      is_all:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoNativeTrend(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
     
    
        payload.report_type,
        payload.start,
        payload.end,
        payload.is_all,
    
       
     
     
      )
      if (response.data) {
        commitPerfettoNativeTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeNativeTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      
      report_type:number|'';
      start:any
      end:any
      type:any
    
      scene_name:any
  
  
    }
  ) {
    try {
      const response = await api.xcodeNativeTrend(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
     
    
        payload.report_type,
        payload.start,
        payload.end,
        payload.type,
     
        payload.scene_name,
    
       
     
     
      )
      if (response.data) {
        commitXcodeNativeTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettNativeFuncTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
  
      report_type:number|'';
      scene_id:any;
      start:string
      end:string
      is_all:string

  
  
    }
  ) {
    try {
      const response = await api.perfettoNativeFuncTrend(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
       
    
        payload.report_type,
        payload.scene_id,
        payload.start,
        payload.end,
        payload.is_all,
        
    
       
     
     
      )
      if (response.data) {
        commitPerfettoNativeFuncTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeNativeFuncTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
  
      report_type:number|'';
      scene_name:any;
      start:string
      end:string
     type:any
     dimension:any

  
  
    }
  ) {
    try {
      const response = await api.xcodeNativeFuncTrend(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
       
    
        payload.report_type,
        payload.scene_name,
        payload.start,
        payload.end,
        payload.type,
        payload.dimension,
        
    
       
     
     
      )
      if (response.data) {
        commitXcodeNativeFuncTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettSoFuncTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
   
      report_type:number|'';
      scene_id:any;
      start:string
      end:string
      so_list:any
      is_all:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoSoFuncTrend(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
        commitPerfettoSoFuncTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeSoFuncTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
   
      report_type:number|'';
      scene_name:any;
      start:string
      end:string
      so_list:any
      type:any
      dimension:any

  
  
    }
  ) {
    try {
      const response = await api.xcodeSoFuncTrend(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
        commitXcodeSoFuncTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSvgLoagUpload(
    context: PerformanceContext,
    payload: {
      project: any;
     name:any
      file:any

  
  
    }
  ) {
    try {
      const response = await api.svgLoagUpload(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemoryUpload(
    context: PerformanceContext,
    payload: {
      project:any,task_id:any,device:any,scenes:any,version:any,up_file:any;tips_up:any

  
  
    }
  ) {
    try {
      const response = await api.memoeryUpload(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDsLoagUpload(
    context: PerformanceContext,
    payload: {
      project: any;
     name:any
      file:any

  
  
    }
  ) {
    try {
      const response = await api.dsLoagUpload(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionNzmSimpleUpload(
    context: PerformanceContext,
    payload: {
      project:any,name:any,file:any,scene_id:any,script_id:any,task_record_id:any,UUID:any 

  
  
    }
  ) {
    try {
      const response = await api.nzmSimpleUpload(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemoryResultUpload(
    context: PerformanceContext,
    payload: {
      project:number,version:any,device_id:any,scene_name:any,file:any,tips_up:any

  
  
    }
  ) {
    try {
      const response = await api.upLoadMemoryResult(
        context.rootState.main.token,
        payload
        
        
    
       
     
     
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettNativeModule(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
     date:string;
     version:string
      scene_id:any
      report_type:any
      is_all:any
      order_by:any,reverse:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoNativeModule(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_id,
        payload.report_type,
        payload.is_all,
        payload.order_by,
        payload.reverse,
    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoNativeModule(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettSoList(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
     date:string;
     version:string
      scene_id:any
      report_type:any
      is_all:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoSoList(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_id,
        payload.report_type,
        payload.is_all,
    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoSoList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettModuleTrend(
    context: PerformanceContext,
    payload: {
      project:number,level:any,report_type:any,scene_name:any,is_all:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoModuleTrend(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.report_type,
        payload.scene_name,
        payload.is_all,

    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoModuleTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettModuleList(
    context: PerformanceContext,
    payload: {
      project:number,level:any,report_type:any,scene_name:any,is_all:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoModuleList(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.report_type,
        payload.scene_name,
        payload.is_all,

    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoModuleList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeSoList(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
     date:string;
     version:string
      scene_name:any
      report_type:any
      type:any
      dimension:any

  
  
    }
  ) {
    try {
      const response = await api.xcodeSoList(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.report_type,
        payload.type,
        payload.dimension,
    
      
    
       
     
     
      )
      if (response.data) {
        return response.data
        // commitXcodeSoList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeNativeModule(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
     date:string;
     version:string
      scene_name:any
      report_type:any
      type:any
      dimension:any
      option:any

  
  
    }
  ) {
    try {
      const response = await api.xcodeNativeModule(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.report_type,
        payload.type,
        payload.dimension,
        payload.option,
    
      
    
       
     
     
      )
      if (response.data) {
       
        commitXcodeNativeModule(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettNativeAll(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_id:any
      top:any
      search:any
      old_date:string;
      old_version:string;  
      order_by:any
      reverse:any
      is_all:any
    

  
  
    }
  ) {
    try {
      const response = await api.perfettoNativeAll(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_id,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.is_all,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoNativeAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeNativeAll(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_name:any
      top:any
      search:any
      old_date:string;
      old_version:string;  
      order_by:any
      reverse:any
      type:any
      dimension:any
    

  
  
    }
  ) {
    try {
      const response = await api.xcodeNativeAll(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.type,
        payload.dimension,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        commitXcodeNativeAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettSoAll(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_id:any
      top:any
      search:any
      old_date:string;
      old_version:string;  
      order_by:any
      reverse:any
      is_all:any
    

  
  
    }
  ) {
    try {
      const response = await api.perfettoSoAll(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_id,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.is_all,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        commitPerfettoSoAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeSoAll(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_name:any
      top:any
      search:any
      old_date:string;
      old_version:string;  
      order_by:any
      reverse:any
      type:any
      dimension:any
    

  
  
    }
  ) {
    try {
      const response = await api.xcodeSoAll(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.type,
        payload.dimension,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        commitXcodeSoAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionObjectFuncAll(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_name:any
      top:any
      search:any
      old_date:string;
      old_version:string;  
      order_by:any
      reverse:any
      report_type:any
    

  
  
    }
  ) {
    try {
      const response = await api.ObjectFuncAll(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.report_type,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        commitObjectFuncAll(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettNativeAllExport(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_id:any
      top:any
      search:any
      old_date:string;
      old_version:string; 
      order_by:any
      reverse:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoNativeAllExport(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_id,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeNativeAllExport(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_name:any
      top:any
      search:any
      old_date:string;
      old_version:string; 
      order_by:any
      reverse:any,
      type:any,
      dimension:any

  
  
    }
  ) {
    try {
      const response = await api.xcodeNativeAllExport(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.type,
        payload.dimension,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettObjectAllExport(
    context: PerformanceContext,
    payload: {
      project: number;
      level:any;
      device_id:number|'';
      date:string;
      version:string
      scene_name:any
      top:any
      search:any
      old_date:string;
      old_version:string; 
      order_by:any
      reverse:any
      report_type:any

  
  
    }
  ) {
    try {
      const response = await api.perfettoObjectAllExport(
        context.rootState.main.token,
        payload.project,
    
        payload.level,
    
        payload.device_id,
        payload.date,
        payload.version,
        payload.scene_name,
        payload.top,
        payload.search,
        payload.old_date,
        payload.old_version,
        payload.order_by,
        payload.reverse,
        payload.report_type,
        
   
    
      
    
       
     
     
      )
      if (response.data) {
        return response.data;
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoReport(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      version:string
      device_id:any
      report_type:any
      is_all:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoReport(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.version,
       
       
        payload.device_id,
        payload.report_type,
        payload.is_all,
       
     
     
      )
      if (response.data) {
        commitPerfettoReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionXcodeReport(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      version:string
      device_id:any
      report_type:any
      type:any

  
    }
  ) {
    try {
      const response = await api.xcodeReport(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.version,
       
       
        payload.device_id,
        payload.report_type,
        payload.type,

       
     
     
      )
      if (response.data) {
        commitXcodeReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoMap(
    context: PerformanceContext,
    payload: {
      project: number;
      level: any;
      task_record_id:any
      device_id:any
     
      scene_name:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoMap(
        context.rootState.main.token,
        payload.project,
        payload.level,
       
        payload.task_record_id,
        payload.device_id,
        payload.scene_name,
       
     
     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoMapData(
    context: PerformanceContext,
    payload: {
      project: number;
      level: any;
      date:any
      version:any
      device_id:any
     
      scene_name:any
  
  
    }
  ) {
    try {
      const response = await api.perfettoMapData(
        context.rootState.main.token,
        payload.project,
        payload.level,
       
        payload.date,
        payload.version,
        payload.device_id,
        payload.scene_name,
       
     
     
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineDevice(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineDevice(
        context.rootState.main.token,
        payload.project,
        payload.date,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeDevice(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineScenes(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineScenes(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeScenes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineSubtypes(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineSubtypes(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeSubtypes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineList(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      subtype:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineOldDate(
    context: PerformanceContext,
    payload: {
      project: number;
     
      device_id:number;
      scene_id:number;
      subtype:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineOldDate(
        context.rootState.main.token,
        payload.project,

        payload.device_id,
        payload.scene_id,
        payload.subtype,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineOldDate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineOldList(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      subtype:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineOldList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeOldList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineThreadOldList(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string;
      device_id:number;
      scene_id:number;
      subtype:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineThreadOldList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.subtype,
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineeThreadOldList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidThreadOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
   
  
  
    }
  ) {
    try {
      const response = await api.androidThreadOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
      
       
     
     
      )
      if (response.data) {
        commitAndroidThreadOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidThreadCompare(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
      old_test:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidThreadCompare(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.old_test,
      
       
     
     
      )
      if (response.data) {
        commitAndroidThreadCompare(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidCourseCompare(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
      old_test:any
   
  
  
    }
  ) {
    try {
      const response = await api.androidCourseCompare(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.old_test,
      
       
     
     
      )
      if (response.data) {
        commitAndroidCourseCompare(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidCourseOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
   
  
  
    }
  ) {
    try {
      const response = await api.androidCourseOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
      
       
     
     
      )
      if (response.data) {
        commitAndroidCourseOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineZip(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
  
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineZip(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
      
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineZip(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidOfflineUrl(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
  
  
  
    }
  ) {
    try {
      const response = await api.androidOfflineUrl(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
     
      
       
     
     
      )
      if (response.data) {
        commitAndroidOfflineUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidCourseTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
      names:any
      start?: any,
      end?: any,
    }
  ) {
    try {
      const response = await api.androidCourseTrend(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.names,
        payload.start,
        payload.end,
      )
      if (response.data) {
        commitAndroidCourseTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidThreadTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      type:number;
      names:any
      start?:any,
      end?:any,
    }
  ) {
    try {
      const response = await api.androidThreadTrend(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.names,
        payload.start,
        payload.end,
      )
      if (response.data) {
        commitAndroidThreadTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuPutDetail(
    context: PerformanceContext,
    payload: { project: number; id_test: any,settings:any,old_test:any,label:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceCpuPutDetail(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetDeepPerformanceCpuPutDetail(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateSkinTab(
    context: PerformanceContext,
    payload: {project:any,id:any,tab_name:string,start_date:any,end_date:any,skin_list:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateSkinTab(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
      return response.data
      }

    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceSimpleDetail(
    context: PerformanceContext,
    payload: { project: number; id_test: any,name:string, }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceSimpleDetail(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetDeepPerformanceSimpleDetail(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuPutCheck(
    context: PerformanceContext,
    payload: { project: number;settings:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceCpuPutCheck(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        commitSetDeepPerformanceCpuPutCheck(context, response.data);
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPerfettoSettingsEdit(
    context: PerformanceContext,
    payload: { project: number;settings:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.perfettoSettingsEdit(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPutLightSmoke(
    context: PerformanceContext,
    payload: { project: number;id: any,index:any,result:any,remark:any,bug_url:any,problem_type:any,light_type:any,mark:any,ai_check:any,ai_check_res?:any  }
  ) {
    try {
      const response = (
        await Promise.all([
          api.putLightSmoke(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPutAabnormalResourceList(
    context: PerformanceContext,
    payload: { project: number;id: any,is_ignore:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.putAabnormalResourceList(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPutResourceConfig(
    context: PerformanceContext,
    payload: { project: number,  name: any,value:any,level:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.putResourceConfig(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPutAssetStack(
    context: PerformanceContext,
    payload: { project: number;id: any,is_ignore:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.putAssetStack(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPutMemoryConfig(
    context: PerformanceContext,
    payload: { project: number;key: any,value:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.putmemoryConfig(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeletePerfetto(
    context: PerformanceContext,
    payload: { project: number;date:string,version:string,device_id:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deletePerfetto(context.rootState.main.token, payload.project, payload.date, payload.version,payload.device_id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteXcode(
    context: PerformanceContext,
    payload: { project: number;date:string,version:string,device_id:any,report_type:any,type:any, }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteXcode(context.rootState.main.token, payload.project, payload.date, payload.version,payload.device_id,payload.report_type,payload.type),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteObject(
    context: PerformanceContext,
    payload: { project: number;date:string,version:string,device_id:any,report_type:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteObject(context.rootState.main.token, payload.project, payload.date, payload.version,payload.device_id,payload.report_type),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteRowObject(
    context: PerformanceContext,
    payload: { project: number;id:any, }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteRowObject(context.rootState.main.token, payload.project, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteSvgLogList(
    context: PerformanceContext,
    payload: { project: number;id:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceSvgLogList(context.rootState.main.token, payload.project, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeletePerformanceImges(
    context: PerformanceContext,
    payload: { project: number;id_test:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deletePerformanceImges(context.rootState.main.token, payload.project, payload.id_test),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteDsLogList(
    context: PerformanceContext,
    payload: { project: number;id:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceDsLogList(context.rootState.main.token, payload.project, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteMemory(
    context: PerformanceContext,
    payload: { project: number;id_test:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteMemory(context.rootState.main.token, payload.project, payload.id_test),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteDeviceModel(
    context: PerformanceContext,
    payload: { project: number;id:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceDeviceModel(context.rootState.main.token, payload.project, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteSkinTab(
    context: PerformanceContext,
    payload: { project: number;id:any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteSkinTab(context.rootState.main.token, payload.project, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuPutConfig(
    context: PerformanceContext,
    payload: { project: number;id_test:any,module_config:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deepPerformanceCpuPutConfig(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
       return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTopDataEdit(
    context: PerformanceContext,
    payload: { project: number;version:any,project_id:any,test_time:any,valid:any }
  ) {
    try {
      const response = (
        await Promise.all([
          api.topDataEdit(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
       return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionTokenLibraryEdit(
    context: PerformanceContext,
    payload: { project: number;id:number;token:string,expiration_time:string}
  ) {
    try {
      const response = (
        await Promise.all([
          api.tokenLibraryEdit(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
       return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuVersionsOld(
    context: PerformanceContext,
    payload: {
      project: number;
     
      device_id?:number,
      scene_id?:number,
      is_auto?:any,
      type?:any,
      subtype?:any
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuVersionsOld(
        context.rootState.main.token,
        payload.project,
        payload?.device_id,
        payload?.scene_id,
        payload?.is_auto,
        payload?.type,
        payload?.subtype,
        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuVersionsOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFunction(
    context: PerformanceContext,
    payload: {
      project: number;
     date:string;
     old_date:string;
      device_id:number,
      scene_id:number,
      version:string,
      old_version:string,
      id_test:any,
      thread:string,
      label:string,
      old_test:any,
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFunction(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.old_date,
        payload.device_id,
        payload.scene_id,
        payload.version,
        payload.old_version,
        payload.id_test,
        payload.thread,
        payload.label,
        payload.old_test,
      )
      if (response.data) {
        commitDeepPerformanceCpuFunction(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFunctionOverview(
    context: PerformanceContext,
    payload: {
      project: number;
     date:string;
     old_date:string;
      device_id:number,
      scene_id:number,
      version:string,
      old_version:string,
      id_test:any,
      old_test:any

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFunctionOverview(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.old_date,
        payload.device_id,
        payload.scene_id,
        payload.version,
        payload.old_version,
        payload.id_test,
        payload.old_test,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuFunctionOverview(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFunctionOverviewNew(
    context: PerformanceContext,
    payload: {
      project: number;
   
      id_test:any,
      old_test:any
      threads?:any

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFunctionOverviewNew(
        context.rootState.main.token,
        payload.project,
       
        payload.id_test,
        payload.old_test,
        payload?.threads,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuFunctionOverview(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuThreadList(
    context: PerformanceContext,
    payload: {
      project: number;
   
      id_test:any,
      old_test:any

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuThreadList(
        context.rootState.main.token,
        payload.project,
       
        payload.id_test,
        payload.old_test,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuThreadList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuCustomData(
    context: PerformanceContext,
    payload: {
      project: number;
   
      id_test:any,
      old_test:any

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuCustomData(
        context.rootState.main.token,
        payload.project,
       
        payload.id_test,
        payload.old_test,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuCustomData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuUsageList(
    context: PerformanceContext,
    payload: {
      project: number;
  
      id_test:any,
      old_test:any
      fps_rate:string

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuUsageList(
        context.rootState.main.token,
        payload.project,
     
        payload.id_test,
        payload.old_test,
        payload.fps_rate,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuUsageList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuUsageListQQ(
    context: PerformanceContext,
    payload: {
      project: number;
  
      id_test:any,
      threads?:any
    

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuUsageListQQ(
        context.rootState.main.token,
        payload.project,
     
        payload.id_test,
        payload?.threads,
 

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuUsageListQQ(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuUsageListModuleQQ(
    context: PerformanceContext,
    payload: {
      project: number;
  
      id_test:any,
    

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuUsageListModuleQQ(
        context.rootState.main.token,
        payload.project,
     
        payload.id_test,
       

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuUsageListModuleQQ(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuReport(
    context: PerformanceContext,
    payload: {
      project: number;
  
      id_test:any,
      old_test:any

  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuReport(
        context.rootState.main.token,
        payload.project,
     
        payload.id_test,
        payload.old_test,

        
     
      )
      if (response.data) {
        commitDeepPerformanceCpuReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformancefuncList(
    context: PerformanceContext,
    payload: {
      project: number;
  
      id_test:any,
      old_test?:any


  
    }
  ) {
    try {
      const response = await api.deepPerformancefuncList(
        context.rootState.main.token,
        payload.project,
     
        payload.id_test,
        payload?.old_test,


        
     
      )
      if (response.data) {
        commitDeepPerformancefuncList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuByFrame(
    context: PerformanceContext,
    payload: {
      project: number;
     date:string;
      device_id:number,
      scene_id:number,
      version:string,
      id_test:any,
      thread:string
      
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuByFrame(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        payload.scene_id,
        payload.version,
        payload.id_test,
        payload.thread,
      
     
      )
      if (response.data) {
        commitDeepPerformanceCpuByFrame(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuThreads(
    context: PerformanceContext,
    payload: {
      project: number;
 
      id_test:any,
  
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuThreads(
        context.rootState.main.token,
        payload.project,
   
        payload.id_test,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuThreads(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceFpsInsideTrend(
    context: PerformanceContext,
    payload: {
      project: number;
 
      id_test:any,
  
    }
  ) {
    try {
      const response = await api.deepPerformanceFpsInsideTrend(
        context.rootState.main.token,
        payload.project,
   
        payload.id_test,
     
      )
      if (response.data) {
        commitDeepPerformanceFpsInsideTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceFlameGraphUrl(
    context: PerformanceContext,
    payload: {
      project: number;
 
      id_test:any,
  
    }
  ) {
    try {
      const response = await api.deepPerformanceFlameGraphUrl(
        context.rootState.main.token,
        payload.project,
   
        payload.id_test,
     
      )
      if (response.data) {
        commitDeepPerformancFlameGraphUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
      threads:any,
      label:any,
      id_test:any,
      is_auto:any,
      type:any,
      subtype:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
        payload.threads,
        payload.label,
        payload.id_test,
        payload.is_auto,
        payload.type,
        payload.subtype,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuThreadTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
   
 
      id_test:any,
      is_auto:any,
      type:any,
      subtype:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuThreadTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
    
     
        payload.id_test,
        payload.is_auto,
        payload.type,
        payload.subtype,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuThreadTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuSoTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
      thread:any,
      label:any
      id_test:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuSoTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
        payload.thread,
        payload.label,
        payload.id_test,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuSoTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuModuleTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      start:string,
      end:string,
      device_id:number,
      scene_id:number,
 
      label:any,
   
      id_test:any,
      is_auto:any,
      type:any,
      subtype:any
    }
  ) {
    try {
      const response = await api.deepPerformanceCpuModuleTrend(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.device_id,
        payload.scene_id,
    
        payload.label,
     
        payload.id_test,
        payload.is_auto,
        payload.type,
        payload.subtype,
     
      )
      if (response.data) {
        commitDeepPerformanceCpuModuleTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionResourceStackOld(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number
      id_row?:number|string;
      depth?:number|string
    }
  ) {
    try {
      const response = await api.pkgResourceStackOld(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload?.id_row,
        payload?.depth,
      )
      if (response.data) {
        commitPkgTypeListOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgTypeTable(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      serch:string;
      page:number;
      size:number
    }
  ) {
    try {
      const response = await api.pkgTypeList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.serch,
        payload.page,
        payload.size,
      )
      if (response.data) {
        commitPkgTypeTable(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgTypeRate(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
  
    }
  ) {
    try {
      const response = await api.pkgTypeRate(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitPkgTypeRate(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgAssetStack(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      is_ignore:any,filename:any,page:any,size:any
  
    }
  ) {
    try {
      const response = await api.pkgAssetStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.is_ignore,
        payload.filename,
        payload.page,
        payload.size,
      
      )
      if (response.data) {
        commitPkgAssetStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgAssetType(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
  
    }
  ) {
    try {
      const response = await api.pkgAssetType(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitPkgAssetType(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgStructStack(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
  
    }
  ) {
    try {
      const response = await api.pkgStructStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitPkgStructStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmFilenameList(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
  
    }
  ) {
    try {
      const response = await api.speedmMemoryFilenameList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitSpeedmFilenameList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmSourceList(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:any;
  
    }
  ) {
    try {
      const response = await api.speedmMemorySourceList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitSpeedmSourceList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmSourceFilesList(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      page:any,
      size:any,
      filename:any
      param:any,reverse:any
  
    }
  ) {
    try {
      const response = await api.speedmMemorySourceFilesList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.page,
        payload.size,
        payload.filename,
        payload.param,
        payload.reverse,
      
      )
      if (response.data) {
        commitSpeedmSourceFilesList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmModSummary(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:any;
      old_test:any;
  
    }
  ) {
    try {
      const response = await api.speedmMemoryModSummary(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
      
      )
      if (response.data) {
        commitSpeedmModSummary(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmModSummaryV1(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:any;
      old_test:any;
      order_by:any,reverse:any
    }
  ) {
    try {
      const response = await api.speedmMemoryModSummaryV1(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
        payload.order_by,
        payload.reverse,
      )
      if (response.data) {
        commitSpeedmModSummaryV1(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryList(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_name: any;
      device_id: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryList(
        context.rootState.main.token,
        payload.project,
        payload.scene_name,
        payload.device_id,
  
      
      )
      if (response.data) {
        commitSpeedmMemoryList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryConfig(
    context: PerformanceContext,
    payload: {
      project: number;
      key:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryConfig(
        context.rootState.main.token,
        payload.project,
        payload.key
  
      
      )
      if (response.data) {
        commitSpeedmMemoryConfig(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemSummartList(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_name: any;
      device_id:any
      start:any
      end:any
      compare:any
      by:any
      page?:any
  
    }
  ) {
    try {
      const response = await api.speedMemSummartList(
        context.rootState.main.token,
        payload.project,
        payload.scene_name,
        payload.device_id,
        payload.start,
        payload.end,
        payload.compare,
        payload.by,
        payload.page
      
      )
      if (response.data) {
        commitMemSummartList(context, response.data);
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemSummaryTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_name: any;
      name:any
      device_type:any
  
  
    }
  ) {
    try {
      const response = await api.speedMemSummaryTrend(
        context.rootState.main.token,
        payload.project,
        payload.scene_name,
        payload.name,
        payload.device_type,
      
  
      
      )
      if (response.data) {
        commitMemSummaryTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemSummaryTrendIOS(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_name: any;
      name:any
      device_type:any
  
  
    }
  ) {
    try {
      const response = await api.speedMemSummaryTrend(
        context.rootState.main.token,
        payload.project,
        payload.scene_name,
        payload.name,
        payload.device_type,
      
  
      
      )
      if (response.data) {
        commitMemSummaryTrendiOS(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemDateVersions(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_name: any;

  
  
    }
  ) {
    try {
      const response = await api.speedMemDateVersions(
        context.rootState.main.token,
        payload.project,
        payload.scene_name,
   
      
  
      
      )
      if (response.data) {
        commitMemDateVersions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemSummartListV1(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: any;
      old_test:any
      
  
    }
  ) {
    try {
      const response = await api.speedMemSummartListV1(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
  
      
      )
      if (response.data) {
        commitMemSummartListV1(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryScens(
    context: PerformanceContext,
    payload: {
      project: number;
      record_id:any
      date:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryScens(
        context.rootState.main.token,
        payload.project,
        payload.record_id,
        payload.date,
  
      
      )
      if (response.data) {
        // commitSpeedmMemoryScens(context, response.data);
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryRecords(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryRecords(
        context.rootState.main.token,
        payload.project,
        payload.date,
      
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryDates(
    context: PerformanceContext,
    payload: {
      project: number;

     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryDates(
        context.rootState.main.token,
        payload.project,
  
      
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceConfig(
    context: PerformanceContext,
    payload: {
      project: number;

     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceConfig(
        context.rootState.main.token,
        payload.project,
  
      
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryDevices(
    context: PerformanceContext,
    payload: {
      project: number;
      version:any
      record_id:any
      date:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryDevices(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.record_id,
        payload.date,
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanDates(
    context: PerformanceContext,
    payload: {
      project: number;
    
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanDates(
        context.rootState.main.token,
        payload.project,
    
  
      
      )
      if (response.data) {
       return commitResourceScanDates(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanCarList(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:any
      scan_type:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanCarList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.scan_type,
    
  
      
      )
      if (response.data) {
       return commitResourceScanCarList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanLoadList(
    context: PerformanceContext,
    payload: {
      project: number;
      car_name:any,id_test:any,scan_type:any
  
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanLoadList(
        context.rootState.main.token,
        payload.project,
        payload.car_name,
        payload.id_test,
        payload.scan_type,
       
    
  
      
      )
      if (response.data) {
       return commitResourceScanLoadList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanSkinList(
    context: PerformanceContext,
    payload: {
      project: number;
      car_name:any,id_test:any,scan_type:any;lod_name:any

     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanSkinList(
        context.rootState.main.token,
        payload.project,
        payload.car_name,
        payload.id_test,
        payload.scan_type,
        payload.lod_name,
  
    
  
      
      )
      if (response.data) {
       return commitResourceScanSkinList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceOverall(
    context: PerformanceContext,
    payload: {
      project: number;
      front:any;
      behind:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceOverall(
        context.rootState.main.token,
        payload.project,
        payload.front,
        payload.behind,
    
  
      
      )
      if (response.data) {
       return commitResourceOverall(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanAverageData(
    context: PerformanceContext,
    payload: {
      project: number;
 
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanAverageData(
        context.rootState.main.token,
        payload.project,
     
    
  
      
      )
      if (response.data) {
        return commitResourceScanAverageData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanChart(
    context: PerformanceContext,
    payload: {
      project: number;
      scan_type:any,car_name:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanChart(
        context.rootState.main.token,
        payload.project,
        payload.scan_type,
        payload.car_name,
     
    
  
      
      )
      if (response.data) {
        return commitResourceScanChart(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceHistory(
    context: PerformanceContext,
    payload: {
      project: number;
  car_name:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceHistory(
        context.rootState.main.token,
        payload.project,
  
        payload.car_name,
     
    
  
      
      )
      if (response.data) {
        return commitResourceHistory(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanChartAvg(
    context: PerformanceContext,
    payload: {
      project: number;
      scan_type:any,car_name:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanChartAvg(
        context.rootState.main.token,
        payload.project,
        payload.scan_type,
        payload.car_name,
    
  
      
      )
      if (response.data) {
        return commitResourceScanChartAvg(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanTypeList(
    context: PerformanceContext,
    payload: {
      project: number;
 
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanTypeList(
        context.rootState.main.token,
        payload.project,
     
    
  
      
      )
      if (response.data) {
        return commitResourceScanTypeList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScanCarData(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:any
     
      car_name:any
      size:any
      page:any
      scan_type:any,lod_name:any,skin_name:any
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanCarData(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.car_name,
        payload.page,
        payload.size,
        payload.scan_type,
        payload.lod_name,
        payload.skin_name,
     
    
  
      
      )
      if (response.data) {
       return commitResourceScanCarData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceRecords(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanRecords(
        context.rootState.main.token,
        payload.project,
        payload.date,
    
  
      
      )
      if (response.data) {
       return commitResourceRecords(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceVersions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
      record_id:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanVersions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.record_id,
    
  
      
      )
      if (response.data) {
       return commitResourceVersions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceDevices(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
      record_id:any
       version:any
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanDevices(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.record_id,
        payload.version,
    
  
      
      )
      if (response.data) {
       return commitResourceDevices(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceScenes(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
      record_id:any
       version:any
       device_name:any
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanScenes(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.record_id,
        payload.version,
        payload.device_name,
    
  
      
      )
      if (response.data) {
       return commitResourceScenes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResourceId(
    context: PerformanceContext,
    payload: {
      project: number;
      date:any
      record_id:any
       version:any
       device_name:any
       scene_name:any
      
  
    }
  ) {
    try {
      const response = await api.speedmResourceScanId(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.record_id,
        payload.version,
        payload.device_name,
        payload.scene_name,
    
  
      
      )
      if (response.data) {
       return commitResourceId(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedHistoryMemoryDevices(
    context: PerformanceContext,
    payload: {
      project: number;
 
     
      
  
    }
  ) {
    try {
      const response = await api.speedmHistoryMemoryDevices(
        context.rootState.main.token,
        payload.project,
   
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryScenes(
    context: PerformanceContext,
    payload: {
      project: number;
      version:any
      record_id:any
      device_id:any
      date:any
      is_remark?: any
    }
  ) {
    try {
      const response = await api.speedmMemoryScenes(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.record_id,
        payload.device_id,
        payload.date,
        payload.is_remark,
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedHistoryMemoryScenes(
    context: PerformanceContext,
    payload: {
      project: number,
      device_id: any,
      is_remark ?: any
    }
  ) {
    try {
      const response = await api.speedmHistoryMemoryScenes(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.is_remark,
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryId(
    context: PerformanceContext,
    payload: {
      project: number;
      version:any
      record_id:any
      device_id:any
      scene_name:any
     
      date:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryId(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.record_id,
        payload.device_id,
        payload.scene_name,
        payload.date,
  
      
      )
      if (response.data) {
       return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmModList(
    context: PerformanceContext,
    payload: {
      project: number;

      device_id:any
      scene_name:any
      start:any,
      end:any
      compare:any
      by:any
      page?: any
      
  
    }
  ) {
    try {
      const response = await api.speedmModList(
        context.rootState.main.token,
        payload.project,
  
        payload.device_id,
        payload.scene_name,
        payload.start,
        payload.end,
        payload.compare,
        payload.by,
        payload.page,
      
      )
      if (response.data) {
        commitSpeedmModList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmExport(
    context: PerformanceContext,
    payload: {
      project: number;

      device_id:any
      scene_name:any
      start:any,
      end:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmExport(
        context.rootState.main.token,
        payload.project,
  
        payload.device_id,
        payload.scene_name,
        payload.start,
        payload.end,
  
      
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionBathchSkinExport(
    context: PerformanceContext,
    payload: {
      project: number;

      skin_tab_id:any
     
     
      
  
    }
  ) {
    try {
      const response = await api.batchSkinExport(
        context.rootState.main.token,
        payload.project,
  
        payload.skin_tab_id,
    
  
      
      )
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmModResList(
    context: PerformanceContext,
    payload: {
      project: number;

      device_id:any
      scene_name:any
      start:any,
      end:any
      compare:any
      by:any
      page?:any
      
  
    }
  ) {
    try {
      const response = await api.speedmModResList(
        context.rootState.main.token,
        payload.project,
  
        payload.device_id,
        payload.scene_name,
        payload.start,
        payload.end,
        payload.compare,
        payload.by,
        payload.page,
      
      )
      if (response.data) {
        commitSpeedmModResList(context, response.data);
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryResSummary(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: any;
      old_test: any;
      filename: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryResSummary(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
        payload.filename,
  
      
      )
      if (response.data) {
        commitSpeedmMemoryResSummary(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryResTrend(
    context: PerformanceContext,
    payload: {
      project: number;

      filename: any;
      scene_name: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryResTrend(
        context.rootState.main.token,
        payload.project,

        payload.filename,
        payload.scene_name,
  
      
      )
      if (response.data) {
        commitSpeedmMemoryResTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmResSummaryList(
    context: PerformanceContext,
    payload: {
      project: number;

      filename: any;
      scene_name: any;
      device:any
     
      
  
    }
  ) {
    try {
      const response = await api.speedmResSummaryList(
        context.rootState.main.token,
        payload.project,

        payload.filename,
        payload.scene_name,
        payload.device,
  
      
      )
      if (response.data) {
        commitSpeedmResSummaryList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmModTrend(
    context: PerformanceContext,
    payload: {
      project: number;

    
      scene_name: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmModTrend(
        context.rootState.main.token,
        payload.project,

        payload.scene_name,
  
      
      )
      if (response.data) {
        commitSpeedmModTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemorySummary(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test: any;
      old_test: any;
      filename: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryResSummary(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
        payload.filename,
  
      
      )
      if (response.data) {
        commitSpeedmMemorySummary(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryTrend(
    context: PerformanceContext,
    payload: {
      project: number;
   
      filename: any;
      scene_name: any;
     
      
  
    }
  ) {
    try {
      const response = await api.speedmMemoryResTrend(
        context.rootState.main.token,
        payload.project,
     
        payload.filename,
        payload.scene_name,
  
      
      )
      if (response.data) {
        commitSpeedmMemoryTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgStrMapStructStack(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      filename:string
  
    }
  ) {
    try {
      const response = await api.pkgMapStructStack(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.filename,
      
      )
      if (response.data) {
        commitPkgMapStructStack(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgStrMapStructStackList(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      filename:string
  
    }
  ) {
    try {
      const response = await api.pkgMapStructStackList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.filename,
      
      )
      if (response.data) {
        commitPkgMapStructStackList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgStrMapStructStackOption(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
  
    }
  ) {
    try {
      const response = await api.pkgMapStructStackOption(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
      )
      if (response.data) {
        commitPkgMapStructStackOption(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionPkgAssetStackFind(
    context: PerformanceContext,
    payload: {
      project: number;
     
      id_test:number;
      name:string;
  
    }
  ) {
    try {
      const response = await api.pkgAssetStackFind(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.name,
      
      )
      if (response.data) {
        commitPkgAssetStackFind(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSmokeByReport(
    context: PerformanceContext,
    payload: {
      project: number;
      page: number;
      size: number;
      start:string;
      end:string,
      search:string
    }
  ) {
    try {
      const response = await api.smokeByReport(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.start,
        payload.end,
        payload.search,
      );
      if (response.data) {
        commitSmokeByReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeScenes(
    context: PerformanceContext,
    payload: {
      project: number;
      light_type: any;
      
    
    }
  ) {
    try {
      const response = await api.lightSmokeScenes(
        context.rootState.main.token,
        payload.project,
        payload.light_type,
     
    
      );
      if (response.data) {
        commitLightSmokeScenes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeVersions(
    context: PerformanceContext,
    payload: {
      project: number;
      light_type: any;
    
      
    
    }
  ) {
    try {
      const response = await api.lightSmokeVersions(
        context.rootState.main.token,
        payload.project,
        payload.light_type,
     
       
    
      );
      if (response.data) {
        commitLightSmokeVersions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightCommonKey(
    context: PerformanceContext,
    payload: {
      project: number;
      key: any;
    
      
    
    }
  ) {
    try {
      const response = await api.lightCommonKey(
        context.rootState.main.token,
        payload
     
     
       
    
      );
      if (response.data) {
        commitLightCommonKey(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightCommonUrl(
    context: PerformanceContext,
    payload: {
      project: number;
      url: any;
    
      
    
    }
  ) {
    try {
      const response = await api.lightCommonUrl(
        context.rootState.main.token,
        payload
        
     
       
    
      );
      if (response.data) {
        commitLightCommonUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeDevices(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      light_type:any
    
    }
  ) {
    try {
      const response = await api.lightSmokeDevices(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.light_type,
    
      );
      if (response.data) {
        commitLightSmokeDevices(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeTodDevices(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      device:string
      light_type:any
    
    }
  ) {
    try {
      const response = await api.lightSmokeTodDevices(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.device,
        payload.light_type,
    
      );
      if (response.data) {
        commitLightSmokeTodDevices(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeList(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      device:string
      version_list:any;
      tod:any,
      test_result:any,
      problem_type:any,
      light_type:any
      ai_check:any
      version?:any
      date?:any
    }
  ) {
    try {
      const response = await api.lightSmokeList(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.device,
        payload.version_list,
        payload.tod,
        payload.test_result,
        payload.problem_type,
        payload.light_type,
        payload.ai_check,
        payload.version,
        payload.date,
      );
      if (response.data) {
        commitLightSmokeList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeListExport(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      device:string
      version_list:any;
      tod:any
    }
  ) {
    try {
      const response = await api.lightSmokeListExport(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.device,
        payload.version_list,
        payload.tod,
    
      );
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeHtmltExport(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      device:string
      version_list:any;
      tod:any
      only_no_pass:any
      light_type:any,test_result:any,problem_type:any
    }
  ) {
    try {
      const response = await api.lightSmokeHtmltExport(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.device,
        payload.version_list,
        payload.tod,
        payload.only_no_pass,
        payload.light_type,
        payload.test_result,
        payload.problem_type,
    
      );
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightSmokeOLhtmlExport(
    context: PerformanceContext,
    payload: {
      project: number;
      scene:string;
      device:string
      version_list:any;
      tod:any
      only_no_pass:any;
      light_type:any,test_result:any,problem_type:any
      
    }
  ) {
    try {
      const response = await api.lightSmokeOLhtmlExport(
        context.rootState.main.token,
        payload.project,
        payload.scene,
        payload.device,
        payload.version_list,
        payload.tod,
        payload.only_no_pass,
        payload.light_type,
        payload.test_result,
        payload.problem_type,
        
    
      );
      if (response.data) {
        return response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSmokeByReportPut(
    context: PerformanceContext,
    payload: { id: number; project: number,remark:any }
  ) {
    try {
      const response = await api.smokeByReportPut(
        context.rootState.main.token,
      
        payload.id,
            payload.project,
            payload
      );
      if (response.data) {
       return  response.data
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSpeedmMemoryListPut(
    context: PerformanceContext,
    payload: { project: number;id: any,remark:any }
  )  {
    try {
      const response = (
        await Promise.all([
          api.EditspeedmMemoryList(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
      
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleTaskOptions(
    context: PerformanceContext,
    payload: {
      project: number;
    }
  ) {
    try {
      const response = await api.simpleTaskOptions(
        context.rootState.main.token,
        payload.project
      );
      if (response.data) {
        commitSimpleTaskOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleTable(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      old_test:number;
      page:number;
      tab:string ;
      process_name:string  
      thread_name:string  
      so_name:string 
      size:string|number
      search:string
      is_null?:any
    }
  ) {
    try {
      const response = await api.simpleTable(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        payload.old_test,
        payload.page,
        payload.tab,
        payload.process_name,
        payload.thread_name,
        payload.so_name,
        payload.size,
        payload.search,
        payload.is_null,
      );
      if (response.data) {
        commitSimpleTable(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleProcessOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      tab:string  
    }
  ) {
    try {
      const response = await api.processOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        payload.tab,
      );
      if (response.data) {
        commitSimpleProcessOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleThreadOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      tab:string ;
      process_name:string;
    }
  ) {
    try {
      const response = await api.threadOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        payload.tab,
        payload.process_name,
      );
      if (response.data) {
        commitSimpleThreadOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleLog(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      old_test
    }
  ) {
    try {
      const response = await api.simpleLog(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        payload.old_test,
      );
      if (response.data) {
        commitSimpleLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleSoOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      tab:string ;
      process_name:string;
      thread_name:string
    }
  ) {
    try {
      const response = await api.soOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        payload.tab,
        payload.process_name,
        payload.thread_name,
      );
      if (response.data) {
        commitSimpleSoOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleTypeOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|''
    }
  ) {
    try {
      const response = await api.simpleTypeOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        

      );
      if (response.data) {
        commitSimpleTypeOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleLabelOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number
    }
  ) {
    try {
      const response = await api.simpleLabelOptions(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        

      );
      if (response.data) {
        commitSimpleLabelOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCpuFuncDeivceOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id: any;
      scene_id: any;
      is_auto:any,
      type:any,
      subtype:any
     
    }
  ) {
    try {
      const response = await api.cpuFuncDeivces(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.is_auto,
        payload.type,
        payload.subtype,
        
      
        

      );
      if (response.data) {
        commitCpuFuncDeivces(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCpuTrend(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id: any;
      scene_id: any;
      is_auto:any,
      type:any,
      subtype:any,
      id_test:any
     
    }
  ) {
    try {
      const response = await api.deepCpuTrend(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.is_auto,
        payload.type,
        payload.subtype,
        payload.id_test,
        
      
        

      );
      if (response.data) {
        commitCpuTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCpuFuncScenesOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      device_id: any;
      scene_id: any;
      is_auto:any,
      type:any,
      subtype:any
    }
  ) {
    try {
      const response = await api.cpuFuncScenes(
        context.rootState.main.token,
        payload.project,
        payload.device_id,
        payload.scene_id,
        payload.is_auto,
        payload.type,
        payload.subtype,
      
        

      );
      if (response.data) {
        commitCpuFuncScenes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleUrl(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number
    }
  ) {
    try {
      const response = await api.simpleUrl(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        

      );
      if (response.data) {
        commitSimpleUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdDeviceptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|''
    }
  ) {
    try {
      const response = await api.abdDeviceptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        

      );
      if (response.data) {
        commitAbdDeviceptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleDeviceOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      report_type:string|number;
      subtype:number;
      scene_id:number
      

    }
  ) {
    try {
      const response = await api.simpleDeviceOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.report_type,
        payload.subtype,
        payload.scene_id,
        

      );
      if (response.data) {
        commitSimpleDeviceOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      report_type:string|number;
      subtype:number;

    }
  ) {
    try {
      const response = await api.simpleSceneOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.report_type,
        payload.subtype,
        

      );
      if (response.data) {
        commitSimpleSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleSubtypeOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      report_type:string|number

    }
  ) {
    try {
      const response = await api.simpleSubtypeOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.report_type,
        

      );
      if (response.data) {
        commitSimpleSubtypeOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdSceneOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      device_id:number|''

    }
  ) {
    try {
      const response = await api.abdSceneOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        

      );
      if (response.data) {
        commitAbdSceneOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdSubtypeOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      device_id:number|''
      scene_id:number|''

    }
  ) {
    try {
      const response = await api.abdSubtypeOptions(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        
        payload.scene_id,
        

      );
      if (response.data) {
        commitAbdSubtypeOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdList(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      device_id:number|''
      scene_id:number|''
      subtype:number|''

    }
  ) {
    try {
      const response = await api.abdList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.device_id,
        
        payload.scene_id,
        payload.subtype,
        

      );
      if (response.data) {
        commitAbdList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdDateSingle(
    context: PerformanceContext,
    payload: {
      project: number;
      scene_id:number|''
      device_id:number|''
      subtype:number|''

    }
  ) {
    try {
      const response = await api.abdDateSingle(
        context.rootState.main.token,
        payload.project,
        payload.scene_id,
        payload.device_id,
        payload.subtype,
        

      );
      if (response.data) {
        commitAbdDateSingle(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdCompare(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any;
      scene_id:number|''
      device_id:number|''
      subtype:number|''

    }
  ) {
    try {
      const response = await api.abdCompare(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
        payload.scene_id,
        payload.device_id,
        payload.subtype,
        

      );
      if (response.data) {
        commitAbdCompare(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdProcessCompare(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      date_list:any;
      scene_id:number|''
      device_id:number|''
      subtype:number|''

    }
  ) {
    try {
      const response = await api.abdProcessCompare(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.date_list,
        payload.scene_id,
        payload.device_id,
        payload.subtype,
        

      );
      if (response.data) {
        commitAbdProcessCompare(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdSum(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number
     

    }
  ) {
    try {
      const response = await api.abdSum(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
        

      );
      if (response.data) {
        commitAbdSum(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdLog(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number
     

    }
  ) {
    try {
      const response = await api.abdLog(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
        

      );
      if (response.data) {
        commitAbdLog(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdUrl(
    context: PerformanceContext,
    payload: {
      project: number;
     id_test:number
     

    }
  ) {
    try {
      const response = await api.abdUrl(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
      
        

      );
      if (response.data) {
        commitAbdUrl(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdType(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number

    }
  ) {
    try {
      const response = await api.abdType(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        

      );
      if (response.data) {
        commitAbdType(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightResource(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number
      data_type:string

    }
  ) {
    try {
      const response = await api.lightResource(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        payload.data_type,
        

      );
      if (response.data) {
        commitLightResource(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidAppFileData(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number

    }
  ) {
    try {
      const response = await api.androidAppFileData(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        

      );
      if (response.data) {
        commitAndroidAppFileData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightJank(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number
      data_type?: string

    }
  ) {
    try {
      const response = await api.lightJank(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        payload?.data_type,
        

      );
      if (response.data) {
        commitLightJank(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionLightMethod(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number
      data_type?: string

    }
  ) {
    try {
      const response = await api.lightMethod(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        payload?.data_type,
        

      );
      if (response.data) {
        commitLightMethod(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAbdProcess(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number|''
      search:string
      size: number | string
      page: number

    }
  ) {
    try {
      const response = await api.abdprocess(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.search,
        payload.size,
        payload.page,
        

      );
      if (response.data) {
        commitAbdProcess(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemoryResouceSpeedOptions(
    context: PerformanceContext,
    payload: {
      project: number;


    }
  ) {
    try {
      const response = await api.memoryResouceSpeedOptions(
        context.rootState.main.token,
        payload.project,
 
        

      );
      if (response.data) {
        commitMemoryResouceSpeedOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionMemoryResouceVehicle(
    context: PerformanceContext,
    payload: {
      project: number,Versions:any,ScanTime:any,RecordID:any,AssetType:any,AssetID:any,AssetSubType:any


    }
  ) {
    try {
      const response = await api.memoryResouceVehicle(
        context.rootState.main.token,
        payload.project,
        payload.Versions,
        payload.ScanTime,
        payload.RecordID,
        payload.AssetType,
        payload.AssetID,
        payload.AssetSubType,
 
 
        

      );
      if (response.data) {
        commitMemoryResouceVehicle(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidCourseProcessList(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number
      type:number
      search:string
      size: number | string
      page: number

    }
  ) {
    try {
      const response = await api.androidCourseProcessList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.search,
        payload.size,
        payload.page,
        

      );
      if (response.data) {
        commitAndroidCourseProcessList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAndroidThreadProcessList(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number
      type:number
      search:string
      size: number | string
      page: number

    }
  ) {
    try {
      const response = await api.androidThreadProcessList(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.type,
        payload.search,
        payload.size,
        payload.page,
        

      );
      if (response.data) {
        commitAndroidThreadProcessList(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepPerformanceCpuFuncReport(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number,old_test:number,thread:string,so:string

    }
  ) {
    try {
      const response = await api.deepPerformanceCpuFuncReport(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.old_test,
        payload.thread,
        payload.so,
 
        

      );
      if (response.data) {
        commitDeepPerformanceCpuFuncReport(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleData(
    context: PerformanceContext,
    payload: {
      project: number;
      date:string|'';
      report_type:string|number;
      UUID:string|number;
      subtype:number;
      id_test:number|''
      scene_id:number

    }
  ) {
    try {
      const response = await api.simpleData(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.report_type,
        payload.UUID,
        payload.subtype,
        payload.id_test,
        payload.scene_id,
        

      );
      if (response.data) {
        commitSimpleData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleByData(
    context: PerformanceContext,
    payload: {
      project: number;
      date?:string|'';
      report_type?:string|number|'';
      UUID?:string|number|'';
      subtype?:number|string|''

    }
  ) {
    try {
      const response = await api.simpleByData(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        payload?.report_type,
        payload?.UUID,
        payload?.subtype,
        

      );
      if (response.data) {
        commitSimpleByData(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleReportOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date?:string|'';
      report_type?:string|number|'';
      UUID?:string|number|'';
      subtype?:number|string|'';
      scene_id:number;

    }
  ) {
    try {
      const response = await api.simpleReportOptions(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        payload?.report_type,
        payload?.UUID,
        payload?.subtype,
        payload?.scene_id,

        

      );
      if (response.data) {
        commitSimpleReportOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleVersionOptions(
    context: PerformanceContext,
    payload: {
      project: number;
      date?:string|'';
      report_type?:string|number|'';
      UUID?:string|number|'';
      subtype?:number|string|'';
      scene_id:number;

    }
  ) {
    try {
      const response = await api.simpleVersionOptions(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        payload?.report_type,
        payload?.UUID,
        payload?.subtype,
        payload?.scene_id,

        

      );
      if (response.data) {
        commitSimpleVersionOptions(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleVersionOptionsOld(
    context: PerformanceContext,
    payload: {
      project: number;
      date?:string|'';
      // report_type?:string|number|'';
      // UUID?:string|number|'';
      // subtype?:number|string|'';
      // scene_id:number;

    }
  ) {
    try {
      const response = await api.simpleVersionOptionsOld(
        context.rootState.main.token,
        payload.project,
        payload?.date,
        // payload?.report_type,
        // payload?.UUID,
        // payload?.subtype,
        // payload?.scene_id,

        

      );
      if (response.data) {
        commitSimpleVersionOptionsOld(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleTrendParams(
    context: PerformanceContext,
    payload: {
      project: number;
      id_test:number;
      Label:string;
      tab:string
    

    }
  ) {
    try {
      const response = await api.simpleTrendParams(
        context.rootState.main.token,
        payload.project,
        payload.id_test,
        payload.Label,
        
       
        payload?.tab,

        

      );
      if (response.data) {
        commitSimpleTrendParams(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSimpleTotalTrend(
    context: PerformanceContext,
    payload: ISimpleTrend
    


    
  ) {
    try {
      const response = await api.simpleTotalTrend(
        context.rootState.main.token,
        payload
        // payload.project,
        // payload?.date,
        // payload?.report_type,
        // payload?.UUID,
        // payload?.subtype,
        // payload?.scene_id,
        // payload?.start,
        // payload?.end,
        // payload?.params,
        // payload?.tab,

        

      );
      if (response.data) {
        commitSimpleTotalTrend(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionSkinLineView(
    context: PerformanceContext,
    payload: {
      project: number;
      pkg: number | string;
      quality: string;
      type: number | string;
      date: number | string;
      mark:string
    }
  ) {
    try {
      const response = await api.skinLineView(
        context.rootState.main.token,
        payload.project,
        payload.pkg,
        payload.quality,
        payload.type,
        payload.date,
        payload.mark
      );
      if (response.data) {
        commitSetSkinLineView(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepSceneOld(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      version?: string;
      scene?: any;
      device?: any;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
    }
  ) {
    try {
      const response = await api.deepSceneOld(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device
      );
      if (response.data) {
        if (payload.type === "object") {
          commitSetDeepSceneOld(context, response.data);
        } else {
          commitSetDeepSceneOldVedio(context, response.data);
        }
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeepFind(
    context: PerformanceContext,
    payload: {
      project: number;
      type: string;
      version?: string;
      scene?: any;
      device?: any;
      inside_scene?: string;
      old_version?: string;
      old_scene?: any;
      old_device?: any;
      old_inside_scene?: string;
      name?: any;
    }
  ) {
    try {
      const response = await api.deepFined(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload?.version,
        payload?.scene,
        payload?.device,
        payload?.inside_scene,
        payload?.old_version,
        payload?.old_scene,
        payload?.old_device,
        payload?.old_inside_scene,
        payload?.name
      );
      if (response.data) {
        commitSetDeepFind(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<PerformanceState | any, State>("");

export const dispatchGetPerformances = dispatch(actions.actionGetPerformances);
export const dispatchUploadPerformance = dispatch(
  actions.actionUploadPerformance
);
export const dispatchDeepCpuUpload = dispatch(
  actions.actionUploadDeepCpuUpload
);
export const dispatchUploadPerformanceUpload = dispatch(
  actions.actionUploadTopPerformanceUpload
);
export const dispatchUploadModelUpload= dispatch(
  actions.actionUploadModelUpload
);
export const dispatchUploadPerformanceTable = dispatch(
  actions.actionUploadTopPerformanceTable
);
export const dispatchTopTemplatesCreate = dispatch(
  actions.actionTopTemplatesCreate
);
export const dispatchTopBaselinesCreate = dispatch(
  actions.actionTopBaselinesCreate
);
export const dispatchTopTemplatesEdit = dispatch(
  actions.actionTopTemplatesEdit
);
export const dispatchTopBaselinesEdit = dispatch(
  actions.actionTopBaselinesEdit
);
export const dispatchUploadTopPerformance= dispatch(
  actions.actionUploadTopPerformance
);
export const dispatchGetProblemSummay= dispatch(
  actions.actionGetProblemSummay
);
export const dispatchGetTopTemplates= dispatch(
  actions.actionGetTopTemplates
);
export const dispatchGetTopBaselines= dispatch(
  actions.actionGetTopBaselines
);
export const dispatchGetTopTemplatesData= dispatch(
  actions.actionGetTopTemplatesData
);
export const dispatchGetTopBaselinesData=dispatch(
  actions.actionGetTopBaselinesData
);
export const dispatchAddBug= dispatch(
  actions.actionAddBug
);
export const dispatchUploadPerformanceAll = dispatch(
  actions.actionUploadPerformanceAll
);
export const dispatchDeepNzmSimpleRetry= dispatch(
  actions.actionDeepNzmSimpleRetry
);
export const dispatchDeepFlameRetry= dispatch(
  actions.actionDeepFlameRetry
);
export const dispatchGetPerformanceTableFields = dispatch(
  actions.actionGetPerformanceTableFields
);
export const dispatchGetPerformanceSelectOptions = dispatch(
  actions.actionGetPerformanceSelectOptions
);
export const dispatchGetPerformanceCustomVersionList= dispatch(
  actions.actionGetPerformanceCustomVersionList
);
export const dispatchGetDateVersionList = dispatch(
  actions.actionGetDateVersionList
);
export const dispatchGetPerformancePageList = dispatch(
  actions.actionGetPerformancePageList
);
export const dispatchGetPerformancePageListSummary = dispatch(
  actions.actionGetPerformancePageListSummary
);
export const dispatchGetTestInfo = dispatch(actions.actionGetTestInfo);
export const dispatchGetLabelInfo = dispatch(actions.actionGetLabelInfo);
export const dispatchGetLabelInfoLabel = dispatch(actions.actionGetLabelInfoLabel);
export const dispatchGetperfInfo = dispatch(actions.actionGetperfInfo);
export const dispatchGetPerfSecondData = dispatch(
  actions.actionGetPerfSecondData
);
export const dispatchGetPerfAvgdData = dispatch(actions.actionGetPerfAvgdData);
export const dispatchDownloadCsv = dispatch(actions.actionDownloadCsv);
export const dispatchRemoveCsv = dispatch(actions.actionRemoveCsv);
export const dispatchCreateReport = dispatch(actions.actionCreateReport);
export const dispatchCreateReportByTask = dispatch(
  actions.actionCreateReportByTask
);

export const dispatchGetPerfReport = dispatch(actions.actiongetPerfReport);
export const dispatchGetWeaponDetail = dispatch(actions.actiongetWeaponDetail);
export const dispatchGetLiverfReport = dispatch(actions.actiongetLiveReport);
export const dispatchGetPerfIdTest = dispatch(actions.actiongetPerfIdTest);
export const dispatchGetStressPerfReport = dispatch(
  actions.actiongetStressPerfReport
);
export const dispatchGetPerfReportSpeedm = dispatch(
  actions.actiongetPerfReportSpeedm
);
export const dispatchGetPerfReportSpeedmGpu = dispatch(
  actions.actiongetPerfReportSpeedmGpu
);
export const dispatchGetNzmGpuReport = dispatch(
  actions.actiongetNzmGpuReport
);
export const dispatchAovCopyPerfToReport = dispatch(
  actions.actionAovCopyPerfToReport
);
export const dispatchGetReportList = dispatch(actions.actionGetReportList);
export const dispatchGetReportDetail = dispatch(actions.actionGetReportDetail);
export const dispatchGetReportSmgReport= dispatch(actions.actionGetReportSmgDetail);
export const dispatchGetNewReportList = dispatch(
  actions.actionGetNewReportList
);
export const dispatchGetLiveReportList = dispatch(
  actions.actionGetLiveReportList
);
export const dispatchUploadReportImage = dispatch(
  actions.actionUploadReportImage
);
export const dispatchUploadGamesReportImage = dispatch(
  actions.actionUploadGamesReportImage
);
export const dispatchUploadCpuReport = dispatch(
  actions.actionUploadCpuReport
);
export const dispatchUploadCpuReportNew = dispatch(
  actions.actionUploadCpuReport1
);
export const dispatchUploadPerfettoReport= dispatch(
  actions.actionUploadPerfettoReport
);
export const dispatchUploadXcodeReport= dispatch(
  actions.actionUploadXcodeReport
);
export const dispatchUploadPkgReport = dispatch(
  actions.actionUploadPkgReport
);
export const dispatchNzmUploadReportImage = dispatch(
  actions.actionNzmUploadReportImage
);
export const dispatchUploadReportImageGpu = dispatch(
  actions.actionUploadReportImageGpu
);
export const dispatchSendSpeedmReport = dispatch(
  actions.actionSendSpeedmReport
);
export const dispatchGetPerformanceDashboard = dispatch(
  actions.actionGetPerformanceDashboard
);
export const dispatchGetAllPerformances = dispatch(
  actions.actionGetAllPerformance
);
export const dispatchDeleteReport = dispatch(actions.actionDeleteReport);
export const dispatchUpdateReport = dispatch(actions.actionUpdateReport);
export const dispatchUpdateComReport = dispatch(actions.actionUpdateComReport);
export const dispatchPerforMance = dispatch(actions.actionPerforMance);
export const dispatchDataValid = dispatch(actions.actionDataValid);
export const dispatchAccessUrl = dispatch(actions.actionAccessUrl);
export const dispatchGetPerformanceAnalysis = dispatch(
  actions.actionGetPerformanceAnalysis
);
export const dispatchGetPerformanceAovTrend = dispatch(
  actions.actionGetPerformanceAovTrend
);
export const dispatchPerformanceAovEmail = dispatch(
  actions.actionPerformanceAovEmail
);
export const dispatchGetAovPerformances = dispatch(
  actions.actionGetAovPerformances
);
export const dispatchtaskRecordQuery = dispatch(actions.actiontaskRecordQuery);
export const dispatchtaskRecordDevices = dispatch(
  actions.actiontaskRecordDevices
);
export const dispatchAovPerformanceCopy = dispatch(
  actions.actionAovPerformanceCopy
);
export const dispatchLastRecord = dispatch(actions.actionLastRecord);
export const dispatchRecentTaskrecord = dispatch(
  actions.actionRecentTaskrecord
);
export const dispatchGetCODMReport = dispatch(actions.actionGetCODMReport);
export const dispatchGetCODMReportList = dispatch(
  actions.actionGetCODMReportList
);
export const dispatchDeleteCODMReport = dispatch(
  actions.actionDeleteCODMReport
);
export const dispatchSendCODMReport = dispatch(actions.actionSendCODMReport);
export const dispatchGetTOPReportList = dispatch(
  actions.actionGetTOPReportList
);
export const dispatchGetTOPReportDetail = dispatch(
  actions.actionGetTOPReportDetail
);
export const dispatchGetTOPReport = dispatch(actions.actionGetTOPReport);
export const dispatchGetTOPReportTable = dispatch(
  actions.actionGetTOPReportTable
);
export const dispatchSendTOPReport = dispatch(actions.actionSendTOPReport);
export const dispatchUpdateTOPReport = dispatch(actions.actionUpdateTOPReport);
export const dispatchGetTOPReportTableList = dispatch(
  actions.actionGetTOPReportTableList
);
export const dispatchGetTOPReportGenerate = dispatch(
  actions.actionGetTOPReportGenerate
);
export const dispatchDeleteTOPReport = dispatch(actions.actionDeleteTOPReport);
export const dispatchDeleteTokenList = dispatch(actions.actionDeleteTokenList);
export const dispatchGetXhookReportList = dispatch(
  actions.actionGetXhookReportList
);
export const dispatchGetXhookReport = dispatch(actions.actionGetXhookReport);
export const dispatchSendXhookReport = dispatch(actions.actionSendXhookReport);
export const dispatchDeleteXhookReport = dispatch(
  actions.actionDeleteXhookReport
);
export const dispatchReportCPUMark = dispatch(actions.actionReportCPUMark);
export const dispatchGetWedoReport = dispatch(actions.actionGetWedoReport);
export const dispatchGetSkinReport = dispatch(actions.actionGetSkinReport);
export const dispatchGetSkinReportList = dispatch(actions.actionGetSkinReportList);
export const dispatchGetSkinReportOption = dispatch(actions.actionGetSkinReportOption);
export const dispatchGetSkinReportOptionOld = dispatch(actions.actionGetSkinReportOptionOld);
export const dispatchGetSkinReportWhole = dispatch(actions.actionGetSkinReportWhole);
export const dispatchGetSkinReportdata= dispatch(actions.actionGetSkinReportdata);
export const dispatchGetSkinReportComparedata= dispatch(actions.actionGetSkinReportComparedata);
export const dispatchGetSkinReportInside = dispatch(
  actions.actionGetSkinReportInside
);
export const dispatchGetSmgReport = dispatch(
  actions.actionGetSmgReport
);
export const dispatchGetSkinTableReport = dispatch(
  actions.actionGetSkinTableReport
);
export const dispatchGetArrange= dispatch(
  actions.actionGetArrange
);
export const dispatchGetArrangeByXlsx= dispatch(
  actions.actionGetArrangeByXlsx
);
export const dispatchGetlogDownload = dispatch(actions.actionGetLogDownload);
export const dispatchGetSmokeReport = dispatch(actions.actionGetSmokeReport);
export const dispatchGetProtocolReport = dispatch(actions.actionGetProtocolReport);
export const dispatchGetLoginSmokeReport = dispatch(actions.actionGetLoginSmokeReport);
export const dispatchGetSmokeReportList = dispatch(
  actions.actionGetSmokeReportList
);
export const dispatchGetProtocolList= dispatch(
  actions.actionGetProtocolList
);
export const dispatchGetLoginSmokeReportList = dispatch(
  actions.actionGetLoginSmokeReportList
);
export const dispatchSendSmokeRepor = dispatch(actions.actionSendSmokeReport);
export const dispatchSendProtocolReport = dispatch(actions.actionSendProtocolReport);
export const dispatchSendLoginSmokeport= dispatch(actions.actionSendLoginSmokeport);
export const dispatchDeleteSmokeRepor = dispatch(
  actions.actionDeleteSmokeReport
);
export const dispatchDeleteProtocolReportDetail = dispatch(
  actions.actionDeleteProtocolReportDetail
);
export const dispatchDeleteLoginSmokeport = dispatch(
  actions.actionDeleteLoginSmokeport
);
export const dispatchGetLabelReport = dispatch(actions.actiongetLabelReport);
export const dispatchGetPerformanceVersion = dispatch(
  actions.actionGetPerformanceVersion
);
export const dispatchClearCache = dispatch(actions.actionClearCache);
export const dispatchGetDeepPerformanceSelectOptions = dispatch(
  actions.actionGetDeepPerformanceSelectOptions
);
export const dispatchGetDeepPerformanceSelectOptionsOld = dispatch(
  actions.actionGetDeepPerformanceSelectOptionsOld
);
export const dispatchGetDeepPerformanceSelectOptionsLast = dispatch(
  actions.actionGetDeepPerformanceSelectOptionsLast
);
export const dispatchGetDeepPerformancePageList = dispatch(
  actions.actionGetDeepPerformancePageList
);
export const dispatchGetDeepPerformanceDetails = dispatch(
  actions.actionGetDeepPerformanceDetails
);
export const dispatchGetCaseMonitorList = dispatch(
  actions.actionGetCaseMonitorList
);
export const dispatchGetCaseMonitor= dispatch(
  actions.actionGetCaseMonito
);
export const dispatchGetDeepPerformanceStack = dispatch(
  actions.actionGetDeepPerformanceStack
);
export const dispatchGetNzmMemoryStack = dispatch(
  actions.actionGetNzmMemoryStack
);
export const dispatchGetNzmMemoryStackAll = dispatch(
  actions.actionGetNzmMemoryStackAll
);
export const dispatchGetInstantiation = dispatch(
  actions.actionGetInstantiation
);
export const dispatchGetInstantiations = dispatch(
  actions.actionGetInstantiations
);
export const actionDeleteInstantiation = dispatch(
  actions.actionDeleteInstantiation
);
export const dispatchDeleteSimpleData = dispatch(
  actions.actionDeleteSimpleData
);
export const dispatchDeleteAbd= dispatch(
  actions.actionDeleteAbd
);
export const dispatchDeleteFile= dispatch(
  actions.actionDeleteFile
);
export const dispatchDeleteLight = dispatch(
  actions.actionDeleteLight
);
export const dispatchDeleteOffline = dispatch(
  actions.actionDeleteOffline
);

export const dispatchChangeFPSlte = dispatch(actions.actionChangeFPSlte);
export const dispatchChangeFPSgte = dispatch(actions.actionChangeFPSgte);
export const dispatchGetPlayerid = dispatch(actions.actionGetPlayerid);

export const dispatchGetDc = dispatch(actions.actionGetDc);
export const dispatchGetDcReport = dispatch(actions.actionGetDcReport);
export const dispatchGetDcReportImage = dispatch(
  actions.actionUploadDcReportImage
);
export const dispatchDeepScene = dispatch(actions.actionDeepScene);
export const dispatcheepMemreport = dispatch(actions.actionDeepMemreport);
export const dispatchDeepSceneOptions = dispatch(
  actions.actionDeepSceneOptions
);
export const dispatchDeepMemoryDeviceOptions = dispatch(
  actions.actionDeepMemoryOptions
);
export const dispatchDeepMemoryLlmList = dispatch(
  actions.actionDeepMemoryLlmList
);
export const dispatchDeepMemoryDateOptions= dispatch(
  actions.actionDeepMemoryDateOptions
);
export const dispatchDeepMemorySubSceneOptions= dispatch(
  actions.actionDeepMemorySubSceneOptions
);
export const dispatchDeepMemoryRecordList= dispatch(
  actions.actionDeepMemoryRecordList
);
export const dispatchDeepMemoryTrend = dispatch(
  actions.actionDeepMemoryTrend
);
export const dispatchDeepMemorySceneOptions = dispatch(
  actions.actionDeepMemorySceneOptions
);
export const dispatchDeepMemoryDownLoad = dispatch(
  actions.actionDeepMemoryDownLoad
);
export const dispatchDeepTopDownLoad = dispatch(
  actions.actionDeepTopDownLoad
);
export const dispatchDeepMemoryReport = dispatch(
  actions.actionDeepMemoryReport
);
export const dispatchDeepUnityMemoryReport = dispatch(
  actions.actionDeepUnityMemoryReport
);
export const dispatchDeepUnityMemoryList = dispatch(
  actions.actionDeepUnityMemoryList
);
export const dispatchDeepMemoryCircleChart = dispatch(
  actions.actionDeepMemoryCircleChart
);
export const dispatchDeepMemoryUobject = dispatch(
  actions.actionDeepMemoryUobject
);
export const dispatchDeepMemoryUobjectTrend = dispatch(
  actions.actionDeepMemoryUobjectTrend
);
export const dispatchObjectMemoryDate= dispatch(
  actions.actionDeepMemoryDate
);
export const dispatchObjectMemoryVersion= dispatch(
  actions.actionDeepMemoryVersion
);
export const dispatchObjectMemoryDevice= dispatch(
  actions.actionDeepMemoryDevice
);
export const dispatchObjectMemoryDeviceSecond= dispatch(
  actions.actionDeepMemoryDeviceSecond
);
export const dispatchObjectMemoryScene= dispatch(
  actions.actionDeepMemoryScene
);
export const dispatchObjectMemoryType= dispatch(
  actions.actionDeepMemoryType
);
export const dispatchObjectMemoryDateVersion= dispatch(
  actions.actionDeepMemoryDateVersion
);
export const dispatchObjectMemoryDateVersionNew= dispatch(
  actions.actionDeepMemoryDateVersionNew
);
export const dispatchObjectMemoryDateVersionDevice= dispatch(
  actions.actionDeepMemoryDateVersionDevice
);
export const dispatchObjectMemoryDateLevel= dispatch(
  actions.actionObjectMemoryLevel
);
export const dispatchObjectMemorySceneSecond= dispatch(
  actions.actionObjectMemorySceneSecond
);
export const dispatchObjectMemorymoduleAll= dispatch(
  actions.actionObjectMemorymoduleAll
);
export const dispatchObjectMemoryReport= dispatch(
  actions.actionObjectMemoryReport
);
export const dispatchObjectMemoryTrend= dispatch(
  actions.actionObjectMemoryTrend
);
export const dispatchObjectFunctionTrend= dispatch(
  actions.actionObjectFunctionTrend
);
export const dispatchObjectFunctionId= dispatch(
  actions.actionObjectFunctionId
);
export const dispatchObjectModuleListId=dispatch(
  actions.actionObjectMemoryModuleListId
);
export const dispatchObjectMemoryFileName=dispatch(
  actions.actionObjectMemoryFileName
);
export const dispatchObjectMemoryDownLoad=dispatch(
  actions.actionObjectMemoryDownLoad
);
export const dispatchObjectFunctionTrendDraw= dispatch(
  actions.actionObjectFunctionTrendDraw
);
export const dispatchObjectMemoryList= dispatch(
  actions.actionObjectMemoryList
);
export const dispatchObjectMemoryListData= dispatch(
  actions.actionObjectMemoryListData
);
export const dispatchObjectMemoryStack= dispatch(
  actions.actionObjectMemoryStack
);
export const dispatchObjectMemorySubStack= dispatch(
  actions.actionObjectMemorySubStack
);
export const dispatchObjectMemoryAllStack= dispatch(
  actions.actionObjectMemoryAllStack
);
export const dispatchObjectMemoryAppointStack= dispatch(
  actions.actionObjectMemoryAppointStack
);
export const dispatchObjectMemoryAppointOldLeftStack= dispatch(
  actions.actionObjectMemoryAppointOldLeftStack
);
export const dispatchObjectMemoryAppointOldRightStack= dispatch(
  actions.actionObjectMemoryAppointOldRightStack
);
export const dispatchObjectMemoryAllStackOld= dispatch(
  actions.actionObjectMemoryAllStackOld
);
export const dispatchObjectMemorySubStackOld= dispatch(
  actions.actionObjectMemorySubStackOld
);
export const dispatchObjectMemoryStackOld= dispatch(
  actions.actionObjectMemoryStackOld
);
export const dispatchObjectModuleList= dispatch(
  actions.actionObjectModuleList
);
export const dispatchObjectFunctionTrendAll= dispatch(
  actions.actionObjectFunctionTrendAll
);
export const dispatchObjectFunctionAppoint= dispatch(
  actions.actionObjectFunctionAppoint
);
export const dispatchObjectFunctionAppointOld= dispatch(
  actions.actionObjectFunctionAppointOld
);
export const dispatchObjectModuleListSecond= dispatch(
  actions.actionObjectModuleListSecond
);
export const dispatchObjectModuleListAppoint= dispatch(
  actions.actionObjectModuleListAppoint
);
export const dispatchObjectModuleListAppointOld= dispatch(
  actions.actionObjectModuleListAppointOld
);
export const dispatchObjectModuleTrend= dispatch(
  actions.actionObjectModuleTrend
);
export const dispatchObjectModuleSubTrend= dispatch(
  actions.actionObjectModuleSubTrend
);
export const dispatchDeepMemreportData = dispatch(
  actions.actionMemreportData
);
export const dispatchDeepMemoryData= dispatch(
  actions.actionGetDeepMemoryData
);
export const dispatchDeepMemoryDataCread= dispatch(
  actions.actionGetDeepMemoryDataCread
);
export const dispatchDeepMemoryDataCreadOld= dispatch(
  actions.actionGetDeepMemoryDataCreadOld
);
export const dispatchDeepSceneOld = dispatch(actions.actionDeepSceneOld);
export const dispatchDeepFind = dispatch(actions.actionDeepFind);
export const dispatchGetTaskList = dispatch(actions.actionGeTaskList);
export const dispatchGetSkinManagement = dispatch(actions.actionSkinManagement);
export const dispatchGetSgameSkinOption = dispatch(actions.actionSgameSkinOption);
export const dispatchGetSgameSkinData= dispatch(actions.actionSgameSkinData);
export const dispatchGetSgameSkinListGet = dispatch(actions.actionSkinTabListGet);
export const dispatchGetSgameSkinTabList = dispatch(actions.actionSgameSkinTabList);
export const dispatchGetSkinLinePkg = dispatch(actions.actionSkinLinePkg);
export const dispatchGetSkinLineDate = dispatch(actions.actionSkinLineDate);
export const dispatchGetSkinLineView = dispatch(actions.actionSkinLineView);
export const dispatchUpdateSkinLineView = dispatch(
  actions.actionUpdateSkinLineView
);
export const dispatchgetTestCase = dispatch(actions.actionTestCase);
export const dispatchgetTestCaseList = dispatch(actions.actionTestCaseList);
export const dispatchCaseControl = dispatch(actions.actionCaseControl);
export const dispatchCaseDetail = dispatch(actions.actionCaseDetail);
export const dispatchDeepPerformanceCheck = dispatch(actions.actionDeepPerformanceCheck);
export const dispatchDeepPerformancSummaryEdit = dispatch(actions.actionDeepPerformancSummaryEdit);
export const dispatchSimpleDateOptions = dispatch(actions.actionSimpleDateOptions);
export const dispatchLightPerfDate = dispatch(actions.actionLightPerfDate);
export const dispatchAndroidAppDate= dispatch(actions.actionAndroidAppDate);
export const dispatchLightPerfDateContrast = dispatch(actions.actionLightPerfDateContrast);
export const dispatchAndroidAppDateContrast = dispatch(actions.actionAndroidAppDateContrast);
export const dispatchLightPerfTrend = dispatch(actions.actionLightPerfTrend);
export const dispatchAndroidAppFileTrend= dispatch(actions.actionAndroidAppFileTrend);
export const dispatchLightPerfResourceCost = dispatch(actions.actionLightPerfResourceCost);
export const dispatchAndroidAppFileCompare = dispatch(actions.actionAndroidAppFileCompare);
export const dispatchLightPerfJankCost= dispatch(actions.actionLightPerfJankCost);
export const dispatchLightPerfMethodCost= dispatch(actions.actionLightPerfMethodCost);
export const dispatchLightPerfFunctions= dispatch(actions.actionLightPerfFunctions);
export const dispatchLightPerfUrl= dispatch(actions.actionLightPerfUrl);
export const dispatchAndroidAppFilename= dispatch(actions.actionAndroidAppFilename);
export const dispatchAndroidAppFileUrl= dispatch(actions.actionAndroidAppFileUrl);
export const dispatchLightPerfDevice = dispatch(actions.actionLightPerfDevice);
export const dispatchAndroidAppDevice = dispatch(actions.actionAndroidAppDevice);
export const dispatchAndroidAppZip = dispatch(actions.actionAndroidAppZip);
export const dispatchLightPerfScene= dispatch(actions.actionLightPerfScene);
export const dispatchAndroidAppScene= dispatch(actions.actionAndroidAppScene);
export const dispatchLightPerfSubtype = dispatch(actions.actionLightSubtype);
export const dispatchAndroidAppSubtype = dispatch(actions.actionAndroidAppSubtype);
export const dispatchLightPerfLog = dispatch(actions.actionLightLog);
export const dispatchLightPerfEditLog = dispatch(actions.actionLightPerfEditLog);
export const dispatchAndroidAppLog= dispatch(actions.actionAndroidAppLog);
export const dispatchAbdDateOptions = dispatch(actions.actionAbdDateOptions);
export const dispatchPkgResourceDate = dispatch(actions.actionPkgResourceDate);
export const dispatchPkgResourceDevice= dispatch(actions.actionPkgResourceDevice);
export const dispatchPkgResourceScenes= dispatch(actions.actionPkgResourceScenes);
export const dispatchPkgResourceList= dispatch(actions.actionPkgResourceList);
export const dispatchPkgResourceReport= dispatch(actions.actionPkgResourceReport);
export const dispatchPkgResourceAbnormalList= dispatch(actions.actionPkgResourceAbnormalList);
export const dispatchPkgResourceAbnormalFile= dispatch(actions.actionPkgResourceAbnormalFile);
export const dispatchPkgResourceListOld= dispatch(actions.actionPkgResourceListOld);
export const dispatchPkgResourceListThreadOld= dispatch(actions.actionPkgResourceListThreadOld);
export const dispatchPkgResourceSum= dispatch(actions.actionResourceSum);
export const dispatchPkgResourceTrend= dispatch(actions.actionResourceTrend);
export const dispatchPkgAssetTrend= dispatch(actions.actionAssetTrend);
export const dispatchPkgStructTrend= dispatch(actions.actionStructTrend);
export const dispatchAbnormalTrend= dispatch(actions.actionAbnormalTrend);
export const dispatchPkgMapStructTrend= dispatch(actions.actionMapStructTrend);
export const dispatchPkgResourceStack= dispatch(actions.actionResourceStack);
export const dispatchPkgResourceStackOld= dispatch(actions.actionResourceStackOld);
export const dispatchPkgTypeTable= dispatch(actions.actionPkgTypeTable);
export const dispatchPkgTypeRate= dispatch(actions.actionPkgTypeRate);
export const dispatchPkgAssetStack= dispatch(actions.actionPkgAssetStack);
export const dispatchPkgAssetType= dispatch(actions.actionPkgAssetType);
export const dispatchPkgStructStack= dispatch(actions.actionPkgStructStack);
export const dispatchSpeedmMemoryList=dispatch(actions.actionSpeedmMemoryList);
export const dispatchSpeedmMemoryConfig=dispatch(actions.actionSpeedmMemoryConfig);
export const dispatchMemSummaryList=dispatch(actions.actionMemSummartList);
export const dispatchMemSummaryTrend=dispatch(actions.actionMemSummaryTrend);
export const dispatchMemSummaryTrendIos=dispatch(actions.actionMemSummaryTrendIOS);
export const dispatchMemDateVersions=dispatch(actions.actionMemDateVersions);
export const dispatchMemSummaryListV1=dispatch(actions.actionMemSummartListV1);
export const dispatchSpeedmMemoryScens=dispatch(actions.actionSpeedmMemoryScens);
export const dispatchSpeedmMemoryRecords=dispatch(actions.actionSpeedmMemoryRecords);
export const dispatchSpeedmMemoryDates=dispatch(actions.actionSpeedmMemoryDates);
export const dispatchSpeedmResourceConfig=dispatch(actions.actionSpeedmResourceConfig);
export const dispatchSpeedmMemoryDevices=dispatch(actions.actionSpeedmMemoryDevices);
export const dispatchResourceScanDates=dispatch(actions.actionSpeedmResourceScanDates);
export const dispatchResourceScanCarList=dispatch(actions.actionSpeedmResourceScanCarList);
export const dispatchResourceScanLoadList=dispatch(actions.actionSpeedmResourceScanLoadList);
export const dispatchResourceScanSkinList=dispatch(actions.actionSpeedmResourceScanSkinList);
export const dispatchResourceOverall=dispatch(actions.actionSpeedmResourceOverall);
export const dispatchResourceScanAverageData=dispatch(actions.actionSpeedmResourceScanAverageData);
export const dispatchResourceScanChart=dispatch(actions.actionSpeedmResourceScanChart);
export const dispatchResourceHistory=dispatch(actions.actionSpeedmResourceHistory);
export const dispatchResourceScanChartAvg=dispatch(actions.actionSpeedmResourceScanChartAvg);
export const dispatchResourceScanTypeList=dispatch(actions.actionSpeedmResourceScanTypeList);
export const dispatchResourceScanCarData=dispatch(actions.actionSpeedmResourceScanCarData);
export const dispatchResourceScanRecords=dispatch(actions.actionSpeedmResourceRecords);
export const dispatchResourceScanVersions=dispatch(actions.actionSpeedmResourceVersions);
export const dispatchResourceScanDevices=dispatch(actions.actionSpeedmResourceDevices);
export const dispatchResourceScanScenes=dispatch(actions.actionSpeedmResourceScenes);
export const dispatchResourceScanId=dispatch(actions.actionSpeedmResourceId);
export const dispatchSpeedHistoryMemoryDevices=dispatch(actions.actionSpeedHistoryMemoryDevices);
export const dispatchSpeedmMemoryScenes=dispatch(actions.actionSpeedmMemoryScenes);
export const dispatchSpeedHistoryMemoryScenes=dispatch(actions.actionSpeedHistoryMemoryScenes);
export const dispatchSpeedmMemoryId=dispatch(actions.actionSpeedmMemoryId);
export const dispatchSpeedmFilenameList=dispatch(actions.actionSpeedmFilenameList);
export const dispatchSpeedmSourceList=dispatch(actions.actionSpeedmSourceList);
export const dispatchSpeedmSourceFileList=dispatch(actions.actionSpeedmSourceFilesList);
export const dispatchSpeedModSummary=dispatch(actions.actionSpeedmModSummary);
export const dispatchSpeedModSummaryV1=dispatch(actions.actionSpeedmModSummaryV1);
export const dispatchSpeedmMemoryResSummary=dispatch(actions.actionSpeedmMemoryResSummary);
export const dispatchSpeedmMemoryModList=dispatch(actions.actionSpeedmModList);
export const dispatchSpeedmMemoryExport=dispatch(actions.actionSpeedmExport);
export const dispatchBathchSkinExport=dispatch(actions.actionBathchSkinExport);
export const dispatchSpeedmMemoryModResList=dispatch(actions.actionSpeedmModResList);
export const dispatchSpeedmMemorySummary=dispatch(actions.actionSpeedmMemorySummary);
export const dispatchSpeedmMemoryTrend=dispatch(actions.actionSpeedmMemoryTrend);
export const dispatchSpeedmMemoryResTrend=dispatch(actions.actionSpeedmMemoryResTrend);
export const dispatchSpeedmResSummaryList=dispatch(actions.actionSpeedmResSummaryList);
export const dispatchSpeedmModTrend=dispatch(actions.actionSpeedmModTrend);
export const dispatchPkgMapStructStack= dispatch(actions.actionPkgStrMapStructStack);
export const dispatchPkgMapStructStackList= dispatch(actions.actionPkgStrMapStructStackList);
export const dispatchPkgMapStructStackOption= dispatch(actions.actionPkgStrMapStructStackOption);
export const dispatchPkgAssetStackFind= dispatch(actions.actionPkgAssetStackFind);
export const dispatchSmokeByReport = dispatch(actions.actionSmokeByReport);
export const dispatchLightSmokeScenes = dispatch(actions.actionLightSmokeScenes);
export const dispatchLightSmokeVersions = dispatch(actions.actionLightSmokeVersions);
export const dispatchLightCommonKey= dispatch(actions.actionLightCommonKey);
export const dispatchLightCommonUrl= dispatch(actions.actionLightCommonUrl);
export const dispatchLightSmokeDevices = dispatch(actions.actionLightSmokeDevices);
export const dispatchLightSmokeTodDevices= dispatch(actions.actionLightSmokeTodDevices);
export const dispatchLightSmokeList= dispatch(actions.actionLightSmokeList);
export const dispatchLightSmokeListExport= dispatch(actions.actionLightSmokeListExport);
export const dispatchLightSmokeHtmltExport= dispatch(actions.actionLightSmokeHtmltExport);
export const dispatchLightSmokeOLhtmlExport= dispatch(actions.actionLightSmokeOLhtmlExport);
export const dispatchSmokeByReportPut = dispatch(actions.actionSmokeByReportPut);
export const dispatchSpeedmMemoryListPut= dispatch(actions.actionSpeedmMemoryListPut);
export const dispatchSimpleTypeOptions = dispatch(actions.actionSimpleTypeOptions);
export const dispatchSimpleProcessOptions = dispatch(actions.actionSimpleProcessOptions);
export const dispatchSimpleSoOptions = dispatch(actions.actionSimpleSoOptions);
export const dispatchimpleThreadOptions = dispatch(actions.actionSimpleThreadOptions);
export const dispatchimpleLog= dispatch(actions.actionSimpleLog);
export const dispatchSimpleTable = dispatch(actions.actionSimpleTable);
export const dispatchSimpleLabelOptions = dispatch(actions.actionSimpleLabelOptions);
export const dispatchCpuFuncDeivceOptions = dispatch(actions.actionCpuFuncDeivceOptions);
export const dispatchCpuTrend = dispatch(actions.actionCpuTrend);
export const dispatchCpuFuncScenesOptions = dispatch(actions.actionCpuFuncScenesOptions);
export const dispatchSimpleUrl = dispatch(actions.actionSimpleUrl);
export const dispatchAbdDeviceptions = dispatch(actions.actionAbdDeviceptions);
export const dispatchAbdSceneOptions = dispatch(actions.actionAbdSceneOptions);
export const dispatchAbdSubtypeOptions = dispatch(actions.actionAbdSubtypeOptions);
export const dispatchAbdList = dispatch(actions.actionAbdList);
export const dispatchAbdSum = dispatch(actions.actionAbdSum);
export const dispatchAbdLog = dispatch(actions.actionAbdLog);
export const dispatchAbdUrl= dispatch(actions.actionAbdUrl);
export const dispatchAbdType = dispatch(actions.actionAbdType);
export const dispatchLightResource= dispatch(actions.actionLightResource);
export const dispatchAndroidAppFileData= dispatch(actions.actionAndroidAppFileData);
export const dispatchLightJank= dispatch(actions.actionLightJank);
export const dispatchLightMethod= dispatch(actions.actionLightMethod);
export const dispatchAbdDateSingle = dispatch(actions.actionAbdDateSingle);
export const dispatchAbdCompare = dispatch(actions.actionAbdCompare);
export const dispatchAbdProcessCompare= dispatch(actions.actionAbdProcessCompare);
export const dispatchAbdProcess = dispatch(actions.actionAbdProcess);
export const dispatchMemoryResouceSpeedOptions = dispatch(actions.actionMemoryResouceSpeedOptions);
export const dispatchMemoryResouceVehicle = dispatch(actions.actionMemoryResouceVehicle);
export const dispatchSimpleDeviceOptions = dispatch(actions.actionSimpleDeviceOptions);
export const dispatchSimpleSceneOptions = dispatch(actions.actionSimpleSceneOptions);
export const dispatchSimpleReportOptions = dispatch(actions.actionSimpleReportOptions);
export const dispatchSimpleVersionOptions = dispatch(actions.actionSimpleVersionOptions);
export const dispatchSimpleVersionOptionsOld = dispatch(actions.actionSimpleVersionOptionsOld);
export const dispatchSimpleTrendParams = dispatch(actions.actionSimpleTrendParams);
export const dispatchSimpleTotalTrend = dispatch(actions.actionSimpleTotalTrend);
export const dispatchSimpleSubtypeOptions = dispatch(actions.actionSimpleSubtypeOptions);
export const dispatchSimpleData = dispatch(actions.actionSimpleData);
export const dispatchSimpleByData = dispatch(actions.actionSimpleByData);
export const dispatchSimpleUpdateReport = dispatch(actions.actionSimpleUpdateReport);
export const dispatchSendMemory = dispatch(actions.actionSendMemory);
export const dispatchDeepPerformanceCpuLabels= dispatch(actions.actionDeepPerformanceCpuLabels);
export const dispatchDeepPerformanceCpuUsageTrend= dispatch(actions.actionDeepPerformanceCpuUsageTrend);
export const dispatchDeepPerformanceCpuLabelsOld= dispatch(actions.actionDeepPerformanceCpuLabelsOld);
export const dispatchDeepPerformanceCpuPerfTrend= dispatch(actions.actionDeepPerformanceCpuPerfTrend);
export const dispatchDeepPerformanceCpuCustomTrend= dispatch(actions.actionDeepPerformanceCpuCustomTrend);
export const dispatchDeepPerformanceCpuCpuThreads= dispatch(actions.actionDeepPerformanceCpuThreads);
export const dispatchDeepPerformanceFpsInsideTrend= dispatch(actions.actionDeepPerformanceFpsInsideTrend);
export const dispatchDeepPerformanceFlameGraphUrl= dispatch(actions.actionDeepPerformanceFlameGraphUrl);
export const dispatchDeepPerformanceCpuCpuTrend= dispatch(actions.actionDeepPerformanceCpuTrend);
export const dispatchDeepPerformanceCpuThreadTrend= dispatch(actions.actionDeepPerformanceCpuThreadTrend);
export const dispatchDeepPerformanceCpuCpuSoTrend= dispatch(actions.actionDeepPerformanceCpuSoTrend);
export const dispatchDeepPerformanceCpuCpuVersions= dispatch(actions.actionDeepPerformanceCpuVersions);
export const  dispatcDeepPerformanceCpufuncTrend= dispatch(actions.actionDeepPerformanceCpufuncTrend);
export const dispatchDeepPerformanceCpuCpuConfig= dispatch(actions.actionDeepPerformanceCpuConfig);
export const dispatchDeepPerformanceCpuCpuConfigSoList= dispatch(actions.actionDeepPerformanceCpuConfigSoList);
export const dispatchDeepPerformanceCpuCpuVersionsOld= dispatch(actions.actionDeepPerformanceCpuVersionsOld);
export const dispatchDeepPerformanceCpuCpuFunction= dispatch(actions.actionDeepPerformanceCpuFunction);
export const dispatchDeepPerformanceCpuCpuFunctionOverview= dispatch(actions.actionDeepPerformanceCpuFunctionOverview);
export const dispatchDeepPerformanceCpuCpuFunctionOverviewNew= dispatch(actions.actionDeepPerformanceCpuFunctionOverviewNew);
export const dispatchDeepPerformanceCpuThreadList= dispatch(actions.actionDeepPerformanceCpuThreadList);
export const dispatchDeepPerformanceCpuCustomData= dispatch(actions.actionDeepPerformanceCpuCustomData);
export const dispatchDeepPerformanceCpuUsageList= dispatch(actions.actionDeepPerformanceCpuUsageList);
export const dispatchDeepPerformanceCpuUsageListQQ= dispatch(actions.actionDeepPerformanceCpuUsageListQQ);
export const dispatchDeepPerformanceCpuUsageListModuleQQ= dispatch(actions.actionDeepPerformanceCpuUsageListModuleQQ);
export const dispatchDeepPerformanceCpuReport= dispatch(actions.actionDeepPerformanceCpuReport);
export const dispatchDeepPerformancefuncList= dispatch(actions.actionDeepPerformancefuncList);
export const dispatchDeepPerformanceCpuCpuByFrame= dispatch(actions.actionDeepPerformanceCpuByFrame);
export const dispatchDeepPerformanceCpuStack= dispatch(actions.actionDeepPerformanceCpuStack);
export const dispatchDeepPerformanceCpuStackMerge= dispatch(actions.actionDeepPerformanceCpuStackMerge);
export const dispatchDeepPerformanceCpuReportText= dispatch(actions.actionDeepPerformanceCpuReportText);
export const dispatchDeepPerformanceFrameProblem= dispatch(actions.actionDeepPerformanceFrameProblem);
export const dispatchDeepPerformanceCatonCreateList= dispatch(actions.actionDeepPerformancCatonCreateList);
export const dispatchDeepPerformanceAvgStack= dispatch(actions.actionDeepPerformanceAvgStack);
export const dispatchTokenLibraryCreate= dispatch(actions.actionTokenLibraryCreate);
export const dispatchTokenLibraryList= dispatch(actions.actionTokenLibraryList);
export const dispatchPerfettoText= dispatch(actions.actionPerfettoText);
export const dispatchDeepPerformanceCpuStackFind= dispatch(actions.actionDeepPerformanceCpuStackFind);
export const dispatchDeepPerformanceCpuStackCreated= dispatch(actions.actionDeepPerformanceCpuStackCreated);
export const dispatchDeepPerformanceCpuStackCreatedOld= dispatch(actions.actionDeepPerformanceCpuStackCreatedOld);
export const dispatchDeepPerformanceCpuFunctionCos= dispatch(actions.actionDeepPerformanceCpuFunctionCos);
export const dispatchDeepPerformanceTrendNode= dispatch(actions.actionDeepPerformanceTrendNode);
export const dispatchDeepPerformanceCpuFunctionModel= dispatch(actions.actionDeepPerformanceCpuFunctionModel);
export const dispatchDeepPerformanceCpuFunctionModuleTrend= dispatch(actions.actionDeepPerformanceCpuModuleTrend);
export const dispatchDeepPerformanceCpuDetail= dispatch(actions.actionDeepPerformanceCpuDetail);
export const dispatchDeepPerformanceCputhreadByFrame= dispatch(actions.actionDeepPerformanceCputhreadByFrame);
export const dispatchDeepPerformanceCatonCheck= dispatch(actions.actionDeepPerformanceCatonCheck);
export const dispatchDeepPerformanceCatonList= dispatch(actions.actionDeepPerformanceCatonList);
export const dispatchDeepPerformanceCpuPutDetail= dispatch(actions.actionDeepPerformanceCpuPutDetail);
export const dispatchUpdateSkinTab= dispatch(actions.actionUpdateSkinTab);
export const dispatchDeepPerformanceSimpleDetail= dispatch(actions.actionDeepPerformanceSimpleDetail);
export const actionDeepPerformanceCpuPutCheck= dispatch(actions.actionDeepPerformanceCpuPutCheck);
export const dispatchPerfettoSettingsEdit= dispatch(actions.actionPerfettoSettingsEdit);
export const dispatchPutLightSmoke= dispatch(actions.actionPutLightSmoke);
export const dispatchPutAabnormalResourceList= dispatch(actions.actionPutAabnormalResourceList);
export const dispatchPutResourceConfig= dispatch(actions.actionPutResourceConfig);
export const dispatchPutAssetStack= dispatch(actions.actionPutAssetStack);
export const dispatchPutMemoryConfig= dispatch(actions.actionPutMemoryConfig);
export const dispatchDeletePerfetto= dispatch(actions.actionDeletePerfetto);
export const dispatchDeleteXcode= dispatch(actions.actionDeleteXcode);
export const dispatchDeleteObject= dispatch(actions.actionDeleteObject);
export const dispatchDeleteRowObject= dispatch(actions.actionDeleteRowObject);
export const dispatchDeleteSvgLogList= dispatch(actions.actionDeleteSvgLogList);
export const dispatchDeletePerformanceImges= dispatch(actions.actionDeletePerformanceImges);
export const dispatchDeleteDsLogList= dispatch(actions.actionDeleteDsLogList);
export const dispatchDeleteMemory= dispatch(actions.actionDeleteMemory);
export const dispatchDeleteDeviceModel= dispatch(actions.actionDeleteDeviceModel);
export const dispatchDeleteSkinTab= dispatch(actions.actionDeleteSkinTab);
export const dispatcDeepPerformanceCpuPutConfig= dispatch(actions.actionDeepPerformanceCpuPutConfig);
export const dispatcTopDataEdit= dispatch(actions.actionTopDataEdit);
export const dispatcTokenLibraryEdit= dispatch(actions.actionTokenLibraryEdit);
export const dispatchAndroidOfflineDate= dispatch(actions.actionAndroidOfflineDate);
export const dispatchPerfettoOptions= dispatch(actions.actionPerfettoOptions);
export const dispatchPerfettoTypeOptions= dispatch(actions.actionPerfettoTypeOptions);
export const dispatchXcodeTypeOptions= dispatch(actions.actionXcodeTypeOptions);
export const dispatchXcodeDateOptions= dispatch(actions.actionXcodeDateOptions);
export const dispatchXcodeDeviceOptions= dispatch(actions.actionXcodeDeviceOptions);
export const dispatchXcodeDimensOptions= dispatch(actions.actionXcodeDimensOptions);
export const dispatchXcodeLevelOptions= dispatch(actions.actionXcodeLevelOptions);
export const dispatchXcodeSceneOptions= dispatch(actions.actionXcodeSceneOptions);
export const dispatchPerfettoSettings= dispatch(actions.actionPerfettoSettings);
export const dispatchPerformanceSvgLog= dispatch(actions.actionPerformanceSvgLog);
export const dispatchPerformanceDsLog= dispatch(actions.actionPerformanceDsLog);
export const dispatchPerformanceSvgLogData= dispatch(actions.actionPerformanceSvgLogData);
export const dispatchPerformanceDsLogData= dispatch(actions.actionPerformanceDsLogData);
export const dispatchPerfettoOptionsOld= dispatch(actions.actionPerfettoOptionsOld);
export const dispatchPerfettoOldOptions= dispatch(actions.actionPerfettoOldOptions);
export const dispatchPerfettoDownLoadStack= dispatch(actions.actionPerfettoDownLoadStack);
export const dispatchPerfettoDownLoadDimensionStack= dispatch(actions.actionPerfettoDownLoadDimensionStack);
export const dispatchPerfettoFileName= dispatch(actions.actionPerfettoFileName);
export const dispatchXcodeFileName= dispatch(actions.actionXcodeFileName);
export const dispatchPerfettoDeviceOptions= dispatch(actions.actionPerfettoDeviceOptions);
export const dispatchPerfettoDeviceOptionsTrend= dispatch(actions.actionPerfettoDeviceOptionsTrend);
export const dispatchPerfettoLevelOptions= dispatch(actions.actionPerfettoLevelOptions);
export const dispatchPerfettoStack= dispatch(actions.actionPerfettoStack);
export const dispatchXcodeStack= dispatch(actions.actionXcodeStack);
export const dispatchPerfettoStackSearch= dispatch(actions.actionPerfettoStackSearch);
export const dispatchPerfettoStackSearchV2= dispatch(actions.actionPerfettoStackSearchV2);
export const dispatchPerfettoStackSearchFuncitons= dispatch(actions.actionPerfettoStackSearchFuncitons);
export const dispatchPerfettoStackSearchSo= dispatch(actions.actionPerfettoStackSearchSo);
export const dispatchPerfettoTraces= dispatch(actions.actionPerfettoTraces);
export const dispatchPerfettoLevelOptionsImportant= dispatch(actions.actionPerfettoLevelOptionsImportant);
export const dispatchPerfettoDeviceOptionsImportant= dispatch(actions.actionPerfettoDeviceOptionsImportant);
export const dispatchPerfettoSceneOptions= dispatch(actions.actionPerfettoSceneOptions);
export const dispatchPerfettoNativeTrend= dispatch(actions.actionPerfettNativeTrend);
export const dispatchXcodeNativeTrend= dispatch(actions.actionXcodeNativeTrend);
export const dispatchPerfettoNativeFuncTrend= dispatch(actions.actionPerfettNativeFuncTrend);
export const dispatchXcodeNativeFuncTrend= dispatch(actions.actionXcodeNativeFuncTrend);
export const dispatchPerfettoSoFuncTrend= dispatch(actions.actionPerfettSoFuncTrend);
export const dispatchXcodeSoFuncTrend= dispatch(actions.actionXcodeSoFuncTrend);
export const dispatchSvgLoagUpload= dispatch(actions.actionSvgLoagUpload);
export const dispatchMemoryUpload= dispatch(actions.actionMemoryUpload);
export const dispatchDsLoagUpload= dispatch(actions.actionDsLoagUpload);
export const dispatchNzmSimpleUpload= dispatch(actions.actionNzmSimpleUpload);
export const dispatchMemoryResultUpload= dispatch(actions.actionMemoryResultUpload);
export const dispatchPerfettoNativeModule= dispatch(actions.actionPerfettNativeModule);
export const dispatchPerfettoSoList= dispatch(actions.actionPerfettSoList);
export const dispatchPerfettoModuleTrend= dispatch(actions.actionPerfettModuleTrend);
export const dispatchPerfettoModuleList= dispatch(actions.actionPerfettModuleList);
export const dispatchXcodeSoList= dispatch(actions.actionXcodeSoList);
export const dispatchXcodeNativeModule= dispatch(actions.actionXcodeNativeModule);
export const dispatchPerfettoNativeAll= dispatch(actions.actionPerfettNativeAll);
export const dispatchXcodeNativeAll= dispatch(actions.actionXcodeNativeAll);
export const dispatchPerfettoSoAll= dispatch(actions.actionPerfettSoAll);
export const dispatchXcodeSoAll= dispatch(actions.actionXcodeSoAll);
export const dispatchObjectFuncAll= dispatch(actions.actionObjectFuncAll);
export const dispatchPerfettoNativeAllExport= dispatch(actions.actionPerfettNativeAllExport);
export const dispatchXcodeNativeAllExport= dispatch(actions.actionXcodeNativeAllExport);
export const dispatchPerfettoObjectExport= dispatch(actions.actionPerfettObjectAllExport);
export const dispatchPerfettoReport= dispatch(actions.actionPerfettoReport);
export const dispatchXcodeReport= dispatch(actions.actionXcodeReport);
export const dispatchPerfettoMap= dispatch(actions.actionPerfettoMap);
export const dispatchPerfettoMapData= dispatch(actions.actionPerfettoMapData);
export const dispatchAndroidOfflineDevice= dispatch(actions.actionAndroidOfflineDevice);
export const dispatchAndroidOfflineScenes= dispatch(actions.actionAndroidOfflineScenes);
export const dispatchAndroidOfflineSubtypes= dispatch(actions.actionAndroidOfflineSubtypes);
export const dispatchAndroidOfflineList= dispatch(actions.actionAndroidOfflineList);
export const dispatchAndroidThreadOptions= dispatch(actions.actionAndroidThreadOptions);
export const dispatchAndroidCourseOptions= dispatch(actions.actionAndroidCourseOptions);
export const dispatchAndroidCourseTrend= dispatch(actions.actionAndroidCourseTrend);
export const dispatchAndroidThreadTrend= dispatch(actions.actionAndroidThreadTrend);
export const dispatchAndroidCourseProcessList= dispatch(actions.actionAndroidCourseProcessList);
export const dispatchAndroidThreadProcessList= dispatch(actions.actionAndroidThreadProcessList);
export const dispatchAndroidOfflineOldList= dispatch(actions.actionAndroidOfflineOldList);
export const dispatchAndroidOfflineThreadOldList= dispatch(actions.actionAndroidOfflineThreadOldList);
export const dispatchAndroidThreadCompare= dispatch(actions.actionAndroidThreadCompare);
export const dispatchAndroidCourseCompare= dispatch(actions.actionAndroidCourseCompare);
export const dispatchAndroidOfflineZip= dispatch(actions.actionAndroidOfflineZip);
export const dispatchAndroidOfflineUrl= dispatch(actions.actionAndroidOfflineUrl);
export const dispatchAndroidOfflineOldDate= dispatch(actions.actionAndroidOfflineOldDate);
export const dispatchDeepPerformanceCpuFuncReport= dispatch(actions.actionDeepPerformanceCpuFuncReport);
export const dispatchDeletetopPerformance= dispatch(actions.actionDeletetopPerformance);
